/*
 * @Description: 聊天模块国际化文案
 */
export default {
    zh: {
        // Chat 页面 Tab
        tabChat: 'Chat',
        creation: '创作',
        historyRecord: '历史记录',
        dialogueRecord: '对话记录',
        systemPromptEntry: '系统提示词',
        systemPromptTitle: '系统提示词',
        systemPromptSubtitle: '这些指令会在每次对话时优先提供给 AI。',
        systemPromptPlaceholder: '在这里输入…',
        openSidebar: '打开侧边栏',
        // 聊天历史记录
        noChat: '你还没有产生过对话哦～',
        newChat: '新建对话',
        rename: '重命名',
        changeName: '修改名称',
        renameChatTitle: '重命名对话',
        renameChatPlaceholder: '请输入新名称',
        renameSuccess: '重命名成功',
        renameFailed: '重命名失败',
        renameChatLimitTip: '字符限制为{max}个',
        // 创作历史记录
        noCreation: '暂无创作记录',
        newCreation: '新建创作',
        delete: '删除',
        deleteSuccess: '删除成功',
        deleteFailed: '删除失败',
        sendFailed: '发送失败，请重试',
        needSendFirstMessage: '请先发送第一条消息',
        loadingMore: '加载更多消息...',
        operationFailed: '操作失败',

        // 减少对话弹窗
        reduceDialogueTitle: '减少对话弹窗',
        reduceDialogueSubtitle: '检测到对话窗口中包含记录。减少窗口数量将移除部分对话及其记录。',
        reduceDialogueSelect: '请选择 {count} 个要关闭的窗口',
        windowName: '窗口{index}',
        noRecords: '暂无记录',
        confirmDelete: '确认删除',

        // 关闭对话弹窗
        closeDialogueTitle: '关闭对话',
        closeDialogueSubtitle1: '关闭此窗口将同时删除该窗口内的所有对话记录。',
        closeDialogueSubtitle2: '此操作无法撤销，确定要继续吗？',

        // 删除聊天弹窗
        deleteChatTitle: '删除对话？',
        deleteChatConfirmMessage: '删除后当前对话记录将不会保留',

        // 聊天空状态
        emptyGreeting: '你好,',
        emptySubtitle1: '我今天能帮你',
        emptySubtitle2: '什么?',

        // 消息操作
        copy: '复制',
        copyText: '复制正文',
        copySuccess: '复制成功',
        cancelEdit: '取消',
        sendEdit: '发送',
        retry: '重试',
        clickToResend: '点击后可以重新发出',
        insufficientCreditsReply: '剩余积分不足，无法进行对话。请充值后继续使用。',
        streamingTimeoutReply: '响应超时，请重试',
        getMoreCredits: '获取更多积分',

        // 模型选择
        switchModel: '切换模型',
        model: '模型',
        credits: '积分',

        // 通用操作
        edit: '编辑',
        cancel: '取消',
        confirm: '确定',
        processing: '处理中...',
        saving: '保存中...',
        save: '保存',
        enableDialogueModalTitle: '提示',
        enableDialogueModalContent: '请开启你要使用的对话框',
        enableDialogueTip: '启用对话框',
        disableDialogueTip: '关闭对话框',

        // 消息操作菜单
        startNewChatFromHere: '从此处开始新聊天',

        // 心声相关
        viewHeart: '查看心声',
        heartMoment: '内心时刻',
        unlocking: '解锁中...',
        unlock: '解锁',

        // 语音引导
        voiceGuideText: '开启开关后，角色回复将自动生成语音播放。',

        // 媒体生成弹窗
        imageGeneration: '生成图片',
        videoGeneration: '生成视频',
        imageSubtitle: '基于当前对话，为您生成专属画面',
        videoSubtitle: '赋予静止的画面以生命，记录流动的时光',
        character: '角色',
        currentCharacter: '当前角色',
        uploadYourPhoto: '上传你的照片',
        optional: '(可选)',
        imageHint: '您可以上传一张自己的照片，我将根据您的外貌特征生成我们两人的合照。若不上传，我将生成一张基于当前对话的单人照发给您。',
        videoHint: '您可以上传一张自己的照片，生成与角色的双人动态视频。若不上传，将生成角色的单人演绎视频。',
        isPublic: '是否公开',
        startGenerate: '开始生成',

        // 媒体结果弹窗
        generatingImage: '图片生成中...',
        generatingVideo: '视频生成中...',
        imageGeneratingSubtitle: '照片生成需要一点时间。完成后，我会直接把照片发送到我们的聊天框中，你可以先去聊天。',
        videoGeneratingSubtitle: '视频生成需要一点时间。完成后，我会直接把视频发送到我们的聊天框中，你可以先去聊天。',
        continueChat: '继续聊天',
        imageComplete: '生成完成',
        videoComplete: '生成完成',
        imageCompleteSubtitle: '这是属于我们的回忆',
        videoCompleteSubtitle: '这是属于我们的回忆',
        saveImage: '保存照片',
        saveVideo: '保存视频',
        generateFailed: '生成失败，请稍后重试',
        gotIt: '我知道了',

        // 聊天输入
        inputPlaceholder: '你要说些什么',

        // 编辑消息弹窗
        editMessage: '编辑消息',
        editDialogueTitle: '对话编辑',
        editPlaceholder: '请输入消息内容',
        editHint: '提示：使用 () 来包裹角色的动作、神态或环境的描写',

        // 回溯确认弹窗
        rollbackTitle: '从此处开始新聊天',
        rollbackMessage: '从此处开始聊天后，将会删除以下的所有聊天，是否确定？',

        // 模式选择器
        switchChatMode: '切换聊天模式',
        subscribe: '订阅',
        freeUnlimitedChat: '免费畅聊',
        vipMemberBanner: '开通会员 畅想',
        unlimitedChat: '无限对话',
        vipDescription: '烈火、悠闲 双重极致体验',
        vipDescriptionSuffix: 'VIP 0金币无限聊，释放你的所有想象。',
        vipFree: 'VIP免费',
        vipOnly: '仅限VIP',
        perMessage: '/条',
        saveChanges: '保存更改',

        // 消息列表
        messageList: '消息列表',
        recent: '最近',
        recentChats: '最近聊天角色',
        loading: '加载中...',
        emoji: '[表情]',
        image: '[图片]',
        audio: '[语音]',

        // 聊天页面空状态
        selectChatToStart: '选择一个聊天开始对话',
        selectFromList: '从左侧列表中选择或创建新的对话',
        selectChatForDetail: '选择聊天查看角色详情',

        // Toast 消息
        toast: {
            noTopics: '暂无推荐话题',
            getTopicsFailed: '获取推荐话题失败',
            noMessageToRefresh: '没有可刷新的消息',
            editSuccess: '修改成功',
            editFailed: '修改失败',
            operationSuccess: '操作成功',
            operationFailed: '操作失败',
            selectImageFile: '请选择图片文件',
            imageSizeLimit: '图片大小不能超过100MB',
            uploading: '正在上传...',
            uploadSuccess: '上传成功',
            uploadFailed: '上传失败',
            insufficientCoins: '金币不足，请先充值',
            noImageToSave: '暂无图片可保存',
            noVideoToSave: '暂无视频可保存',
            saveSuccess: '保存成功',
            saveFailed: '保存失败，请重试',
            mediaLoadFailed: '媒体加载失败',
            switchSuccess: '已切换到',
            switchFailed: '切换模式失败',
            networkError: '网络错误，请重试',
            waitForAiReply: '请等待AI回复',
            sendFailed: '发送失败，请重试',
            regenerateFailed: '重新生成失败，请重试',
            waitTimeout: '等待超时，请重试',
            audioGenerateSuccess: '语音生成成功',
            conversationNotExist: '会话不存在',
            audioGenerateFailed: '生成语音失败',
            mediaGenerating: '正在生成中...',
            imageGenerating: '图片生成中...',
            videoGenerating: '视频生成中...',
            mediaGenerateFailed: '生成失败，请重试',
            mediaNetworkError: '网络错误，请重试',
            heartUnlockSuccess: '解锁成功',
            heartUnlockFailed: '解锁失败',
        },
    },
    en: {
        // Chat Page Tab
        tabChat: 'Chat',
        creation: 'Creation',
        historyRecord: 'History',
        dialogueRecord: 'Dialogue History',
        systemPromptEntry: 'System Prompt',
        systemPromptTitle: 'System Prompt',
        systemPromptSubtitle: 'These instructions will be given to the AI first in every conversation.',
        systemPromptPlaceholder: 'Type here…',
        openSidebar: 'Open sidebar',
        // Chat History
        noChat: "You haven't started any conversation yet~",
        newChat: 'New Chat',
        rename: 'Rename',
        changeName: 'Change name',
        renameChatTitle: 'Rename Conversation',
        renameChatPlaceholder: 'Please enter a new name',
        renameSuccess: 'Renamed successfully',
        renameFailed: 'Rename failed',
        renameChatLimitTip: 'Character limit is {max}',
        // Creation History
        noCreation: 'No Creation Yet',
        newCreation: 'New Creation',
        delete: 'Delete',
        deleteSuccess: 'Deleted successfully',
        deleteFailed: 'Delete failed',
        sendFailed: 'Failed to send, please try again',
        needSendFirstMessage: 'Please send the first message first',
        loadingMore: 'Loading more messages...',
        operationFailed: 'Operation failed',

        // Reduce Dialogue Modal
        reduceDialogueTitle: 'Reduce Dialogue Windows',
        reduceDialogueSubtitle: 'Records detected in dialogue windows. Reducing window count will remove some dialogues and their records.',
        reduceDialogueSelect: 'Please select {count} window(s) to close',
        windowName: 'Window {index}',
        noRecords: 'No records',
        confirmDelete: 'Confirm Delete',

        // Close Dialogue Modal
        closeDialogueTitle: 'Close Dialogue',
        closeDialogueSubtitle1: 'Closing this window will delete all dialogue records in this window.',
        closeDialogueSubtitle2: 'This action cannot be undone. Are you sure you want to continue?',

        // Delete Chat Modal
        deleteChatTitle: 'Delete conversation?',
        deleteChatConfirmMessage: 'After deletion, the current conversation records will not be retained.',

        // Chat Empty State
        emptyGreeting: 'Hello,',
        emptySubtitle1: 'How can I help you',
        emptySubtitle2: 'today?',

        // Message Actions
        copy: 'Copy',
        copyText: 'Copy Text',
        copySuccess: 'Copied!',
        cancelEdit: 'Cancel',
        sendEdit: 'Send',
        retry: 'Retry',
        clickToResend: 'Click to resend',
        insufficientCreditsReply: 'Insufficient credits. Please recharge to continue.',
        streamingTimeoutReply: 'Response timed out, please retry',
        getMoreCredits: 'Get More Credits',

        // Model Selection
        switchModel: 'Switch Model',
        model: 'Model',
        credits: 'credits',

        // Common operations
        edit: 'Edit',
        cancel: 'Cancel',
        confirm: 'Confirm',
        processing: 'Processing...',
        saving: 'Saving...',
        save: 'Save',
        enableDialogueModalTitle: 'Tip',
        enableDialogueModalContent: 'Please enable the dialogue window you want to use.',
        enableDialogueTip: 'Enable this dialogue',
        disableDialogueTip: 'Disable this dialogue',

        // Message action menu
        startNewChatFromHere: 'Start new chat from here',

        // Heart related
        viewHeart: 'View Heart',
        heartMoment: 'Heart Moment',
        unlocking: 'Unlocking...',
        unlock: 'Unlock',

        // Voice guide
        voiceGuideText: 'When enabled, character replies will automatically generate voice playback.',

        // Media generation modal
        imageGeneration: 'Generate Image',
        videoGeneration: 'Generate Video',
        imageSubtitle: 'Generate exclusive visuals based on the current conversation',
        videoSubtitle: 'Bring still images to life, capture flowing moments',
        character: 'Character',
        currentCharacter: 'Current Character',
        uploadYourPhoto: 'Upload your photo',
        optional: '(Optional)',
        imageHint: 'You can upload a photo of yourself, and I will generate a photo of both of us based on your appearance. If not uploaded, I will generate a solo photo based on the current conversation.',
        videoHint: 'You can upload a photo of yourself to generate a duo video with the character. If not uploaded, a solo character video will be generated.',
        isPublic: 'Make Public',
        startGenerate: 'Start Generate',

        // Media result modal
        generatingImage: 'Generating image...',
        generatingVideo: 'Generating video...',
        imageGeneratingSubtitle: 'Photo generation takes a moment. Once complete, I will send the photo directly to our chat. Feel free to continue chatting.',
        videoGeneratingSubtitle: 'Video generation takes a moment. Once complete, I will send the video directly to our chat. Feel free to continue chatting.',
        continueChat: 'Continue Chat',
        imageComplete: 'Generation Complete',
        videoComplete: 'Generation Complete',
        imageCompleteSubtitle: 'This is our exclusive memory',
        videoCompleteSubtitle: 'This is our exclusive memory',
        saveImage: 'Save Photo',
        saveVideo: 'Save Video',
        generateFailed: 'Generation failed, please try again later',
        gotIt: 'Got it',

        // Chat input
        inputPlaceholder: 'What would you like to say',

        // Edit message modal
        editMessage: 'Edit Message',
        editDialogueTitle: 'Edit Message',
        editPlaceholder: 'Please enter message content',
        editHint: 'Tip: Use () to wrap character actions, expressions, or environment descriptions',

        // Rollback confirmation modal
        rollbackTitle: 'Start new chat from here',
        rollbackMessage: 'Starting chat from here will delete all subsequent messages. Are you sure?',

        // Mode selector
        switchChatMode: 'Switch Chat Mode',
        subscribe: 'Subscribe',
        freeUnlimitedChat: 'Free Unlimited Chat',
        vipMemberBanner: 'Become VIP and enjoy',
        unlimitedChat: 'Unlimited Chat',
        vipDescription: 'Intense & Chill dual experience',
        vipDescriptionSuffix: 'VIP 0 coins unlimited chat, unleash all your imagination.',
        vipFree: 'VIP Free',
        vipOnly: 'VIP Only',
        perMessage: '/msg',
        saveChanges: 'Save Changes',

        // Message list
        messageList: 'Messages',
        recent: 'Recent',
        recentChats: 'Recent Chats',
        loading: 'Loading...',
        emoji: '[Emoji]',
        image: '[Image]',
        audio: '[Audio]',

        // Chat page empty state
        selectChatToStart: 'Select a chat to start',
        selectFromList: 'Select from the list or create a new conversation',
        selectChatForDetail: 'Select a chat to view character details',

        // Toast messages
        toast: {
            noTopics: 'No recommended topics available',
            getTopicsFailed: 'Failed to get recommended topics',
            noMessageToRefresh: 'No message to refresh',
            editSuccess: 'Edit successful',
            editFailed: 'Edit failed',
            operationSuccess: 'Operation successful',
            operationFailed: 'Operation failed',
            selectImageFile: 'Please select an image file',
            imageSizeLimit: 'Image size cannot exceed 100MB',
            uploading: 'Uploading...',
            uploadSuccess: 'Upload successful',
            uploadFailed: 'Upload failed',
            insufficientCoins: 'Insufficient coins, please recharge',
            noImageToSave: 'No image to save',
            noVideoToSave: 'No video to save',
            saveSuccess: 'Saved successfully',
            saveFailed: 'Save failed, please try again',
            mediaLoadFailed: 'Media failed to load',
            switchSuccess: 'Switched to',
            switchFailed: 'Failed to switch mode',
            networkError: 'Network error, please try again',
            waitForAiReply: 'Please wait for AI reply',
            sendFailed: 'Failed to send, please try again',
            regenerateFailed: 'Failed to regenerate, please try again',
            waitTimeout: 'Wait timeout, please try again',
            audioGenerateSuccess: 'Audio generated successfully',
            conversationNotExist: 'Conversation does not exist',
            audioGenerateFailed: 'Failed to generate audio',
            mediaGenerating: 'Generating...',
            imageGenerating: 'Generating image...',
            videoGenerating: 'Generating video...',
            mediaGenerateFailed: 'Generation failed, please try again',
            mediaNetworkError: 'Network error, please try again',
            heartUnlockSuccess: 'Unlocked successfully',
            heartUnlockFailed: 'Failed to unlock',
        },
    },
    ja: {
        // Chat ページタブ
        tabChat: 'チャット',
        creation: '創作',
        historyRecord: '履歴',
        dialogueRecord: '対話記録',
        systemPromptEntry: 'プロンプト',
        systemPromptTitle: 'システムプロンプト',
        systemPromptSubtitle: 'これらの指示は、各会話の際に優先的に AI に提供されます。',
        systemPromptPlaceholder: 'ここに入力…',
        openSidebar: 'サイドバーを開く',
        noChat: 'まだ会話を始めていませんよ～',
        newChat: '新規チャット',
        rename: '名前を変更',
        changeName: '名前を変更',
        renameChatTitle: '会話名を変更',
        renameChatPlaceholder: '新しい名前を入力してください',
        renameSuccess: '名前を変更しました',
        renameFailed: '名前の変更に失敗しました',
        renameChatLimitTip: '文字数制限は{max}文字です',
        noCreation: '作品がありません',
        newCreation: '新規作成',
        delete: '削除',
        deleteSuccess: '削除しました',
        deleteFailed: '削除に失敗しました',
        sendFailed: '送信に失敗しました。もう一度お試しください',
        needSendFirstMessage: '最初のメッセージを送信してください',
        loadingMore: 'さらにメッセージを読み込み中...',

        // ダイアログ削減モーダル
        reduceDialogueTitle: 'ダイアログウィンドウを減らす',
        reduceDialogueSubtitle: 'ダイアログウィンドウに記録が検出されました。ウィンドウ数を減らすと、一部のダイアログとその記録が削除されます。',
        reduceDialogueSelect: '閉じるウィンドウを{count}個選択してください',
        windowName: 'ウィンドウ{index}',
        noRecords: '記録なし',
        cancel: 'キャンセル',
        confirmDelete: '削除確認',

        // ダイアログを閉じるモーダル
        closeDialogueTitle: 'ダイアログを閉じる',
        closeDialogueSubtitle1: 'このウィンドウを閉じると、このウィンドウ内のすべての会話記録が削除されます。',
        closeDialogueSubtitle2: 'この操作は取り消せません。続行しますか？',

        // チャット削除モーダル
        deleteChatTitle: '会話を削除しますか？',
        deleteChatConfirmMessage: '削除後、現在の会話記録は保持されません。',

        // チャット空状態
        emptyGreeting: 'こんにちは、',
        emptySubtitle1: '今日は何をお手伝い',
        emptySubtitle2: 'しましょうか？',

        // メッセージ操作
        copy: 'コピー',
        copyText: 'テキストをコピー',
        copySuccess: 'コピーしました',
        cancelEdit: 'キャンセル',
        sendEdit: '送信',
        retry: 'リトライ',
        clickToResend: 'クリックして再送信',
        insufficientCreditsReply: 'クレジットが不足しています。チャージして続行してください。',
        streamingTimeoutReply: '応答がタイムアウトしました。再試行してください',
        getMoreCredits: 'クレジットを取得',

        // モデル選択
        switchModel: 'モデル切替',
        model: 'モデル',
        credits: 'クレジット',

        // 共通操作
        edit: '編集',
        confirm: '確認',
        processing: '処理中...',
        saving: '保存中...',
        save: '保存',
        enableDialogueModalTitle: 'ヒント',
        enableDialogueModalContent: '使用するダイアログウィンドウを有効にしてください。',
        enableDialogueTip: 'このダイアログを有効にする',
        disableDialogueTip: 'このダイアログを無効にする',

        // メッセージ操作メニュー
        startNewChatFromHere: 'ここから新しいチャットを開始',

        // ハート関連
        viewHeart: '心の声を見る',
        heartMoment: '心の瞬間',
        unlocking: 'アンロック中...',
        unlock: 'アンロック',

        // 音声ガイド
        voiceGuideText: 'オンにすると、キャラクターの返信が自動的に音声再生されます。',

        // メディア生成モーダル
        imageGeneration: '画像生成',
        videoGeneration: '動画生成',
        imageSubtitle: '現在の会話に基づいて、あなただけの特別な画像を生成します',
        videoSubtitle: '静止画像に命を吹き込み、流れる瞬間を記録します',
        character: 'キャラクター',
        currentCharacter: '現在のキャラクター',
        uploadYourPhoto: '写真をアップロード',
        optional: '(任意)',
        imageHint: 'ご自身の写真をアップロードすると、外見の特徴に基づいて二人の写真を生成します。アップロードしない場合は、現在の会話に基づいたソロ写真を生成します。',
        videoHint: 'ご自身の写真をアップロードすると、キャラクターとのデュオ動画を生成します。アップロードしない場合は、キャラクターのソロ動画を生成します。',
        isPublic: '公開設定',
        startGenerate: '生成開始',

        // メディア結果モーダル
        generatingImage: '画像生成中...',
        generatingVideo: '動画生成中...',
        imageGeneratingSubtitle: '画像の生成には少し時間がかかります。完了したら、チャットに直接写真を送信しますので、チャットを続けてお待ちください。',
        videoGeneratingSubtitle: '動画の生成には少し時間がかかります。完了したら、チャットに動画を送信しますので、チャットを続けてお待ちください。',
        continueChat: 'チャットを続ける',
        imageComplete: '生成完了',
        videoComplete: '生成完了',
        imageCompleteSubtitle: 'これは私たちだけの思い出です',
        videoCompleteSubtitle: 'これは私たちだけの思い出です',
        saveImage: '写真を保存',
        saveVideo: '動画を保存',
        generateFailed: '生成に失敗しました。後でもう一度お試しください',
        gotIt: '了解',

        // チャット入力
        inputPlaceholder: '何を話しますか',

        // メッセージ編集モーダル
        editMessage: 'メッセージを編集',
        editDialogueTitle: '会話を編集',
        editPlaceholder: 'メッセージ内容を入力してください',
        editHint: 'ヒント: () を使用してキャラクターの動作、表情、または環境の説明を囲みます',

        // ロールバック確認モーダル
        rollbackTitle: 'ここから新しいチャットを開始',
        rollbackMessage: 'ここからチャットを開始すると、以降のすべてのメッセージが削除されます。よろしいですか？',

        // モード選択
        switchChatMode: 'チャットモードを切替',
        subscribe: '登録する',
        freeUnlimitedChat: '無料で無制限チャット',
        vipMemberBanner: 'VIP会員になって',
        unlimitedChat: '無制限チャット',
        vipDescription: '情熱＆リラックス二重体験',
        vipDescriptionSuffix: 'VIP 0コイン無制限チャット、すべての想像力を解放。',
        vipFree: 'VIP無料',
        vipOnly: 'VIP専用',
        perMessage: '/件',
        saveChanges: '変更を保存',

        // メッセージリスト
        messageList: 'メッセージ',
        recent: '最近',
        recentChats: '最近のチャット',
        loading: '読み込み中...',
        emoji: '[スタンプ]',
        image: '[画像]',
        audio: '[音声]',

        // チャットページ空状態
        selectChatToStart: 'チャットを選択して開始',
        selectFromList: 'リストから選択または新しい会話を作成',
        selectChatForDetail: 'チャットを選択してキャラクター詳細を表示',

        // トーストメッセージ
        toast: {
            noTopics: 'おすすめのトピックがありません',
            getTopicsFailed: 'おすすめトピックの取得に失敗しました',
            noMessageToRefresh: '更新するメッセージがありません',
            editSuccess: '編集成功',
            editFailed: '編集失敗',
            operationSuccess: '操作成功',
            operationFailed: '操作失敗',
            selectImageFile: '画像ファイルを選択してください',
            imageSizeLimit: '画像サイズは100MBを超えることはできません',
            uploading: 'アップロード中...',
            uploadSuccess: 'アップロード成功',
            uploadFailed: 'アップロード失敗',
            insufficientCoins: 'コインが不足しています。チャージしてください',
            noImageToSave: '保存する画像がありません',
            noVideoToSave: '保存する動画がありません',
            saveSuccess: '保存成功',
            saveFailed: '保存に失敗しました。もう一度お試しください',
            mediaLoadFailed: 'メディアの読み込みに失敗しました',
            switchSuccess: '切り替え完了：',
            switchFailed: 'モード切替に失敗しました',
            networkError: 'ネットワークエラー、もう一度お試しください',
            waitForAiReply: 'AIの返答をお待ちください',
            sendFailed: '送信に失敗しました。もう一度お試しください',
            regenerateFailed: '再生成に失敗しました。もう一度お試しください',
            waitTimeout: '待機がタイムアウトしました。もう一度お試しください',
            audioGenerateSuccess: '音声が正常に生成されました',
            conversationNotExist: '会話が存在しません',
            audioGenerateFailed: '音声生成に失敗しました',
            mediaGenerating: '生成中...',
            imageGenerating: '画像生成中...',
            videoGenerating: '動画生成中...',
            mediaGenerateFailed: '生成に失敗しました。再試行してください',
            mediaNetworkError: 'ネットワークエラー。再試行してください',
            heartUnlockSuccess: 'ロック解除に成功しました',
            heartUnlockFailed: 'ロック解除に失敗しました',
        },
    },
    ko: {
        // 채팅 페이지 탭
        tabChat: '채팅',
        creation: '창작',
        historyRecord: '기록',
        dialogueRecord: '대화 기록',
        systemPromptEntry: '프롬프트',
        systemPromptTitle: '시스템 프롬프트',
        systemPromptSubtitle: '이 지시사항은 매 대화마다 AI에게 우선적으로 제공됩니다.',
        systemPromptPlaceholder: '여기에 입력…',
        openSidebar: '사이드바 열기',
        noChat: '아직 대화를 시작하지 않았어요~',
        newChat: '새 대화',
        rename: '이름 변경',
        changeName: '이름 변경',
        renameChatTitle: '대화 이름 변경',
        renameChatPlaceholder: '새 이름을 입력하세요',
        renameSuccess: '이름 변경 성공',
        renameFailed: '이름 변경 실패',
        renameChatLimitTip: '문자 수 제한은 {max}자입니다',
        noCreation: '창작 기록 없음',
        newCreation: '새 창작',
        delete: '삭제',
        deleteSuccess: '삭제되었습니다',
        deleteFailed: '삭제 실패',
        sendFailed: '전송 실패, 다시 시도해 주세요',
        needSendFirstMessage: '먼저 첫 번째 메시지를 보내주세요',
        loadingMore: '더 많은 메시지를 불러오는 중...',

        // 대화 창 줄이기 모달
        reduceDialogueTitle: '대화 창 줄이기',
        reduceDialogueSubtitle: '대화 창에서 기록이 감지되었습니다. 창 수를 줄이면 일부 대화와 기록이 삭제됩니다.',
        reduceDialogueSelect: '닫을 창 {count}개를 선택하세요',
        windowName: '창 {index}',
        noRecords: '기록 없음',
        cancel: '취소',
        confirmDelete: '삭제 확인',

        // 대화 닫기 모달
        closeDialogueTitle: '대화 닫기',
        closeDialogueSubtitle1: '이 창을 닫으면 이 창의 모든 대화 기록이 삭제됩니다.',
        closeDialogueSubtitle2: '이 작업은 취소할 수 없습니다. 계속하시겠습니까?',

        // 채팅 삭제 모달
        deleteChatTitle: '대화를 삭제하시겠습니까?',
        deleteChatConfirmMessage: '삭제 후 현재 대화 기록은 보관되지 않습니다.',

        // 채팅 빈 상태
        emptyGreeting: '안녕하세요,',
        emptySubtitle1: '오늘 무엇을 도와',
        emptySubtitle2: '드릴까요?',

        // 메시지 작업
        copy: '복사',
        copyText: '텍스트 복사',
        copySuccess: '복사됨',
        cancelEdit: '취소',
        sendEdit: '전송',
        retry: '재시도',
        clickToResend: '클릭하여 재전송',
        insufficientCreditsReply: '크레딧이 부족합니다. 충전 후 계속하세요.',
        streamingTimeoutReply: '응답 시간 초과, 다시 시도해 주세요',
        getMoreCredits: '크레딧 충전',

        // 모델 선택
        switchModel: '모델 전환',
        model: '모델',
        credits: '크레딧',

        // 공통 작업
        edit: '편집',
        confirm: '확인',
        processing: '처리 중...',
        saving: '저장 중...',
        save: '저장',
        enableDialogueModalTitle: '안내',
        enableDialogueModalContent: '사용하려는 대화 창을 활성화해 주세요.',
        enableDialogueTip: '이 대화창 활성화',
        disableDialogueTip: '이 대화창 비활성화',

        // 메시지 작업 메뉴
        startNewChatFromHere: '여기서 새 채팅 시작',

        // 하트 관련
        viewHeart: '마음의 소리 보기',
        heartMoment: '마음의 순간',
        unlocking: '잠금 해제 중...',
        unlock: '잠금 해제',

        // 음성 가이드
        voiceGuideText: '활성화하면 캐릭터 응답이 자동으로 음성 재생됩니다.',

        // 미디어 생성 모달
        imageGeneration: '이미지 생성',
        videoGeneration: '동영상 생성',
        imageSubtitle: '현재 대화를 바탕으로 당신만을 위한 전용 이미지를 생성합니다',
        videoSubtitle: '정지 이미지에 생명을 불어넣어 흐르는 순간을 기록합니다',
        character: '캐릭터',
        currentCharacter: '현재 캐릭터',
        uploadYourPhoto: '사진 업로드',
        optional: '(선택)',
        imageHint: '본인 사진을 업로드하면 외모 특징을 기반으로 두 사람의 사진을 생성합니다. 업로드하지 않으면 현재 대화를 기반으로 한 솔로 사진을 생성합니다.',
        videoHint: '본인 사진을 업로드하면 캐릭터와의 듀오 동영상을 생성합니다. 업로드하지 않으면 캐릭터 솔로 동영상을 생성합니다.',
        isPublic: '공개 여부',
        startGenerate: '생성 시작',

        // 미디어 결과 모달
        generatingImage: '이미지 생성 중...',
        generatingVideo: '동영상 생성 중...',
        imageGeneratingSubtitle: '이미지 생성에는 시간이 조금 소요됩니다. 완료되면 채팅방으로 바로 보내드리니, 계속 대화를 나누셔도 됩니다.',
        videoGeneratingSubtitle: '동영상 생성에는 시간이 조금 소요됩니다. 완료되면 채팅방으로 바로 보내드리니, 계속 대화를 나누셔도 됩니다.',
        continueChat: '채팅 계속하기',
        imageComplete: '생성 완료',
        videoComplete: '생성 완료',
        imageCompleteSubtitle: '우리 둘만의 추억입니다',
        videoCompleteSubtitle: '우리 둘만의 추억입니다',
        saveImage: '사진 저장',
        saveVideo: '동영상 저장',
        generateFailed: '생성 실패, 나중에 다시 시도해 주세요',
        gotIt: '알겠습니다',

        // 채팅 입력
        inputPlaceholder: '무엇을 말하고 싶으신가요',

        // 메시지 편집 모달
        editMessage: '메시지 편집',
        editDialogueTitle: '대화 편집',
        editPlaceholder: '메시지 내용을 입력하세요',
        editHint: '팁: ()를 사용하여 캐릭터의 동작, 표정 또는 환경 설명을 감싸세요',

        // 롤백 확인 모달
        rollbackTitle: '여기서 새 채팅 시작',
        rollbackMessage: '여기서 채팅을 시작하면 이후의 모든 메시지가 삭제됩니다. 확실합니까?',

        // 모드 선택
        switchChatMode: '채팅 모드 전환',
        subscribe: '구독',
        freeUnlimitedChat: '무료 무제한 채팅',
        vipMemberBanner: 'VIP 회원이 되어',
        unlimitedChat: '무제한 채팅',
        vipDescription: '열정 & 릴렉스 이중 경험',
        vipDescriptionSuffix: 'VIP 0코인 무제한 채팅, 모든 상상력을 발휘하세요.',
        vipFree: 'VIP 무료',
        vipOnly: 'VIP 전용',
        perMessage: '/건',
        saveChanges: '변경 사항 저장',

        // 메시지 목록
        messageList: '메시지',
        recent: '최근',
        recentChats: '최근 채팅',
        loading: '로딩 중...',
        emoji: '[이모티콘]',
        image: '[이미지]',
        audio: '[음성]',

        // 채팅 페이지 빈 상태
        selectChatToStart: '대화를 시작할 채팅 선택',
        selectFromList: '목록에서 선택하거나 새 대화 만들기',
        selectChatForDetail: '채팅을 선택하여 캐릭터 상세 보기',

        // 토스트 메시지
        toast: {
            noTopics: '추천 주제가 없습니다',
            getTopicsFailed: '추천 주제를 가져오는 데 실패했습니다',
            noMessageToRefresh: '새로 고칠 메시지가 없습니다',
            editSuccess: '편집 성공',
            editFailed: '편집 실패',
            operationSuccess: '작업 성공',
            operationFailed: '작업 실패',
            selectImageFile: '이미지 파일을 선택하세요',
            imageSizeLimit: '이미지 크기는 100MB를 초과할 수 없습니다',
            uploading: '업로드 중...',
            uploadSuccess: '업로드 성공',
            uploadFailed: '업로드 실패',
            insufficientCoins: '코인이 부족합니다. 충전해 주세요',
            noImageToSave: '저장할 이미지가 없습니다',
            noVideoToSave: '저장할 동영상이 없습니다',
            saveSuccess: '저장 성공',
            saveFailed: '저장 실패, 다시 시도해 주세요',
            mediaLoadFailed: '미디어 로드 실패',
            switchSuccess: '전환 완료:',
            switchFailed: '모드 전환 실패',
            networkError: '네트워크 오류, 다시 시도해 주세요',
            waitForAiReply: 'AI 응답을 기다려 주세요',
            sendFailed: '전송 실패, 다시 시도해 주세요',
            regenerateFailed: '재생성 실패, 다시 시도해 주세요',
            waitTimeout: '대기 시간 초과, 다시 시도해 주세요',
            audioGenerateSuccess: '음성이 성공적으로 생성되었습니다',
            conversationNotExist: '대화가 존재하지 않습니다',
            audioGenerateFailed: '음성 생성에 실패했습니다',
            mediaGenerating: '생성 중...',
            imageGenerating: '이미지 생성 중...',
            videoGenerating: '비디오 생성 중...',
            mediaGenerateFailed: '생성 실패, 다시 시도해 주세요',
            mediaNetworkError: '네트워크 오류, 다시 시도해 주세요',
            heartUnlockSuccess: '잠금 해제 성공',
            heartUnlockFailed: '잠금 해제 실패',
        },
    },
    tw: {
        // Chat 頁面 Tab
        tabChat: '聊天',
        creation: '創作',
        historyRecord: '歷史記錄',
        dialogueRecord: '對話記錄',
        systemPromptEntry: '提示詞',
        systemPromptTitle: '系統提示詞',
        systemPromptSubtitle: '這些指令會在每次對話時優先提供給 AI。',
        systemPromptPlaceholder: '在這裡輸入…',
        openSidebar: '開啟側邊欄',
        noChat: '你還沒有產生過對話哦～',
        newChat: '新建對話',
        rename: '重新命名',
        changeName: '修改名稱',
        renameChatTitle: '重新命名對話',
        renameChatPlaceholder: '請輸入新名稱',
        renameSuccess: '重新命名成功',
        renameFailed: '重新命名失敗',
        renameChatLimitTip: '字元限制為{max}個',
        noCreation: '暫無創作記錄',
        newCreation: '新建創作',
        delete: '刪除',
        deleteSuccess: '刪除成功',
        deleteFailed: '刪除失敗',
        sendFailed: '發送失敗，請重試',
        needSendFirstMessage: '請先發送第一條訊息',
        loadingMore: '載入更多訊息...',

        // 減少對話彈窗
        reduceDialogueTitle: '減少對話彈窗',
        reduceDialogueSubtitle: '檢測到對話視窗中包含記錄。減少視窗數量將移除部分對話及其記錄。',
        reduceDialogueSelect: '請選擇 {count} 個要關閉的視窗',
        windowName: '視窗{index}',
        noRecords: '暫無記錄',
        confirmDelete: '確認刪除',

        // 關閉對話彈窗
        closeDialogueTitle: '關閉對話',
        closeDialogueSubtitle1: '關閉此視窗將同時刪除該視窗內的所有對話記錄。',
        closeDialogueSubtitle2: '此操作無法撤銷，確定要繼續嗎？',

        // 刪除聊天彈窗
        deleteChatTitle: '刪除對話？',
        deleteChatConfirmMessage: '刪除後目前對話記錄將不會保留',

        // 聊天空狀態
        emptyGreeting: '你好，',
        emptySubtitle1: '今天我能幫你',
        emptySubtitle2: '什麼？',

        // 訊息操作
        copy: '複製',
        copyText: '複製正文',
        copySuccess: '複製成功',
        cancelEdit: '取消',
        sendEdit: '發送',
        retry: '重試',
        clickToResend: '點擊後可以重新發出',
        insufficientCreditsReply: '剩餘積分不足，無法進行對話。請充值後繼續使用。',
        streamingTimeoutReply: '回應逾時，請重試',
        getMoreCredits: '獲取更多積分',

        // 模型選擇
        switchModel: '切換模型',
        model: '模型',
        credits: '積分',

        // 通用操作
        edit: '編輯',
        cancel: '取消',
        confirm: '確定',
        processing: '處理中...',
        saving: '保存中...',
        save: '保存',
        enableDialogueModalTitle: '提示',
        enableDialogueModalContent: '請開啟你要使用的對話框',
        enableDialogueTip: '啟用對話框',
        disableDialogueTip: '關閉對話框',

        // 訊息操作選單
        startNewChatFromHere: '從此處開始新聊天',

        // 心声相关
        viewHeart: '查看心声',
        heartMoment: '内心时刻',
        unlocking: '解锁中...',
        unlock: '解锁',

        // 语音引导
        voiceGuideText: '开启开关后，角色回复将自动生成语音播放。',

        // 媒体生成弹窗
        imageGeneration: '生成图片',
        videoGeneration: '生成视频',
        imageSubtitle: '基于当前对话，为您生成专属画面',
        videoSubtitle: '赋予静止的画面以生命，记录流动的时光',
        character: '角色',
        currentCharacter: '当前角色',
        uploadYourPhoto: '上传你的照片',
        optional: '(可选)',
        imageHint: '您可以上传一张自己的照片，我将根据您的外貌特征生成我们两人的合照。若不上传，我将生成一张基于当前对话的单人照发给您。',
        videoHint: '您可以上传一张自己的照片，生成与角色的双人动态视频。若不上传，将生成角色的单人演绎视频。',
        startGenerate: '开始生成',

        // 媒体结果弹窗
        generatingImage: '图片生成中...',
        generatingVideo: '视频生成中...',
        imageGeneratingSubtitle: '照片生成需要一点时间。完成后，我会直接把照片发送到我们的聊天框中，你可以先去聊天。',
        videoGeneratingSubtitle: '视频生成需要一点时间。完成后，我会直接把视频发送到我们的聊天框中，你可以先去聊天。',
        continueChat: '继续聊天',
        imageComplete: '生成完成',
        videoComplete: '生成完成',
        imageCompleteSubtitle: '这是属于我们的回忆',
        videoCompleteSubtitle: '这是属于我们的回忆',
        saveImage: '保存照片',
        saveVideo: '保存视频',
        generateFailed: '生成失败，请稍后重试',
        gotIt: '我知道了',

        // 聊天输入
        inputPlaceholder: '你要说些什么',

        // 编辑消息弹窗
        editMessage: '编辑消息',
        editDialogueTitle: '對話編輯',
        editPlaceholder: '请输入消息内容',
        editHint: '提示：使用 () 来包裹角色的动作、神态或环境的描写',

        // 回溯确认弹窗
        rollbackTitle: '从此处开始新聊天',
        rollbackMessage: '从此处开始聊天后，将会删除以下的所有聊天，是否确定？',

        // 模式选择器
        switchChatMode: '切换聊天模式',
        subscribe: '订阅',
        freeUnlimitedChat: '免费畅聊',
        vipMemberBanner: '开通会员 畅想',
        unlimitedChat: '无限对话',
        vipDescription: '烈火、悠闲 双重极致体验',
        vipDescriptionSuffix: 'VIP 0金币无限聊，释放你的所有想象。',
        vipFree: 'VIP免费',
        vipOnly: '仅限VIP',
        perMessage: '/条',
        saveChanges: '保存更改',

        // 消息列表
        messageList: '消息列表',
        recent: '最近',
        recentChats: '最近聊天角色',
        loading: '加载中...',
        emoji: '[表情]',
        image: '[图片]',
        audio: '[语音]',

        // 聊天页面空状态
        selectChatToStart: '选择一个聊天开始对话',
        selectFromList: '从左侧列表中选择或创建新的对话',
        selectChatForDetail: '选择聊天查看角色详情',

        // Toast 消息
        toast: {
            noTopics: '暂无推荐话题',
            getTopicsFailed: '获取推荐话题失败',
            noMessageToRefresh: '没有可刷新的消息',
            editSuccess: '修改成功',
            editFailed: '修改失败',
            operationSuccess: '操作成功',
            operationFailed: '操作失败',
            selectImageFile: '请选择图片文件',
            imageSizeLimit: '图片大小不能超过100MB',
            uploading: '正在上传...',
            uploadSuccess: '上传成功',
            uploadFailed: '上传失败',
            insufficientCoins: '金币不足，请先充值',
            noImageToSave: '暂无图片可保存',
            noVideoToSave: '暂无视频可保存',
            saveSuccess: '保存成功',
            saveFailed: '保存失败，请重试',
            mediaLoadFailed: '媒体加载失败',
            switchSuccess: '已切换到',
            switchFailed: '切换模式失败',
            networkError: '网络错误，请重试',
            waitForAiReply: '请等待AI回复',
            sendFailed: '发送失败，请重试',
            regenerateFailed: '重新生成失败，请重试',
            waitTimeout: '等待超时，请重试',
            audioGenerateSuccess: '语音生成成功',
            conversationNotExist: '会话不存在',
            audioGenerateFailed: '生成语音失败',
            mediaGenerating: '正在生成中...',
            imageGenerating: '图片生成中...',
            videoGenerating: '视频生成中...',
            mediaGenerateFailed: '生成失败，请重试',
            mediaNetworkError: '网络错误，请重试',
            heartUnlockSuccess: '解锁成功',
            heartUnlockFailed: '解锁失败',
        },
    },
    pl: {
        // Zakładka strony czatu
        tabChat: 'Czat',
        creation: 'Tworzenie',
        historyRecord: 'Historia',
        dialogueRecord: 'Historia Dialogu',
        systemPromptEntry: 'Prompt',
        systemPromptTitle: 'Prompt systemowy',
        systemPromptSubtitle: 'Te instrukcje będą priorytetowo przekazywane AI w każdej rozmowie.',
        systemPromptPlaceholder: 'Wpisz tutaj…',
        openSidebar: 'Otwórz pasek boczny',
        noChat: 'Nie zacząłeś jeszcze żadnej rozmowy~',
        newChat: 'Nowy czat',
        rename: 'Zmień nazwę',
        changeName: 'Zmień nazwę',
        renameChatTitle: 'Zmień nazwę rozmowy',
        renameChatPlaceholder: 'Wprowadź nową nazwę',
        renameSuccess: 'Zmieniono nazwę pomyślnie',
        renameFailed: 'Zmiana nazwy nie powiodła się',
        renameChatLimitTip: 'Limit znaków: {max}',
        noCreation: 'Brak twórczości',
        newCreation: 'Nowa twórczość',
        delete: 'Usuń',
        deleteSuccess: 'Usunięto pomyślnie',
        deleteFailed: 'Usuwanie nie powiodło się',
        sendFailed: 'Wysyłanie nie powiodło się, spróbuj ponownie',
        needSendFirstMessage: 'Najpierw wyślij pierwszą wiadomość',
        loadingMore: 'Ładowanie więcej wiadomości...',

        // Modal zmniejszania dialogu
        reduceDialogueTitle: 'Zmniejsz liczbę okien dialogowych',
        reduceDialogueSubtitle: 'Wykryto rekordy w oknach dialogowych. Zmniejszenie liczby okien usunie niektóre dialogi i ich rekordy.',
        reduceDialogueSelect: 'Wybierz {count} okno(a) do zamknięcia',
        windowName: 'Okno {index}',
        noRecords: 'Brak rekordów',
        confirmDelete: 'Potwierdź usunięcie',

        // Modal usuwania czatu
        deleteChatTitle: 'Usunąć rozmowę?',
        deleteChatConfirmMessage: 'Po usunięciu bieżące zapisy rozmowy nie zostaną zachowane.',

        // Stan pustego czatu
        emptyGreeting: 'Cześć,',
        emptySubtitle1: 'W czym mogę ci dzisiaj',
        emptySubtitle2: 'pomóc?',

        // Wybór modelu
        switchModel: 'Przełącz model',
        model: 'Model',
        credits: 'kredytów',

        // Common operations
        edit: 'Edit',
        cancel: 'Cancel',
        confirm: 'Confirm',
        processing: 'Processing...',
        saving: 'Saving...',
        save: 'Save',
        enableDialogueModalTitle: 'Wskazówka',
        enableDialogueModalContent: 'Włącz okno dialogowe, którego chcesz użyć.',
        enableDialogueTip: 'Włącz to okno dialogowe',
        disableDialogueTip: 'Wyłącz to okno dialogowe',

        // Message action menu
        startNewChatFromHere: 'Start new chat from here',

        // Heart related
        viewHeart: 'View Heart',
        heartMoment: 'Heart Moment',
        unlocking: 'Unlocking...',
        unlock: 'Unlock',

        // Voice guide
        voiceGuideText: 'When enabled, character replies will automatically generate voice playback.',

        // Media generation modal
        imageGeneration: 'Generate Image',
        videoGeneration: 'Generate Video',
        imageSubtitle: 'Generate exclusive visuals based on the current conversation',
        videoSubtitle: 'Bring still images to life, capture flowing moments',
        character: 'Character',
        currentCharacter: 'Current Character',
        uploadYourPhoto: 'Upload your photo',
        optional: '(Optional)',
        imageHint: 'You can upload a photo of yourself, and I will generate a photo of both of us based on your appearance. If not uploaded, I will generate a solo photo based on the current conversation.',
        videoHint: 'You can upload a photo of yourself to generate a duo video with the character. If not uploaded, a solo character video will be generated.',
        startGenerate: 'Start Generate',

        // Media result modal
        generatingImage: 'Generating image...',
        generatingVideo: 'Generating video...',
        imageGeneratingSubtitle: 'Photo generation takes a moment. Once complete, I will send the photo directly to our chat. Feel free to continue chatting.',
        videoGeneratingSubtitle: 'Video generation takes a moment. Once complete, I will send the video directly to our chat. Feel free to continue chatting.',
        continueChat: 'Continue Chat',
        imageComplete: 'Generation Complete',
        videoComplete: 'Generation Complete',
        imageCompleteSubtitle: 'This is our exclusive memory',
        videoCompleteSubtitle: 'This is our exclusive memory',
        saveImage: 'Save Photo',
        saveVideo: 'Save Video',
        generateFailed: 'Generation failed, please try again later',
        gotIt: 'Got it',

        // Chat input
        inputPlaceholder: 'What would you like to say',

        // Edit message modal
        editMessage: 'Edit Message',
        editDialogueTitle: 'Edit Message',
        editPlaceholder: 'Please enter message content',
        editHint: 'Tip: Use () to wrap character actions, expressions, or environment descriptions',

        // Rollback confirmation modal
        rollbackTitle: 'Start new chat from here',
        rollbackMessage: 'Starting chat from here will delete all subsequent messages. Are you sure?',

        // Mode selector
        switchChatMode: 'Switch Chat Mode',
        subscribe: 'Subscribe',
        freeUnlimitedChat: 'Free Unlimited Chat',
        vipMemberBanner: 'Become VIP and enjoy',
        unlimitedChat: 'Unlimited Chat',
        vipDescription: 'Intense & Chill dual experience',
        vipDescriptionSuffix: 'VIP 0 coins unlimited chat, unleash all your imagination.',
        vipFree: 'VIP Free',
        vipOnly: 'VIP Only',
        perMessage: '/msg',
        saveChanges: 'Save Changes',

        // Message list
        messageList: 'Messages',
        recent: 'Recent',
        recentChats: 'Recent Chats',
        loading: 'Loading...',
        emoji: '[Emoji]',
        image: '[Image]',
        audio: '[Audio]',

        // Chat page empty state
        selectChatToStart: 'Select a chat to start',
        selectFromList: 'Select from the list or create a new conversation',
        selectChatForDetail: 'Select a chat to view character details',

        // Toast messages
        toast: {
            noTopics: 'No recommended topics available',
            getTopicsFailed: 'Failed to get recommended topics',
            noMessageToRefresh: 'No message to refresh',
            editSuccess: 'Edit successful',
            editFailed: 'Edit failed',
            operationSuccess: 'Operation successful',
            operationFailed: 'Operation failed',
            selectImageFile: 'Please select an image file',
            imageSizeLimit: 'Image size cannot exceed 100MB',
            uploading: 'Uploading...',
            uploadSuccess: 'Upload successful',
            uploadFailed: 'Upload failed',
            insufficientCoins: 'Insufficient coins, please recharge',
            noImageToSave: 'No image to save',
            noVideoToSave: 'No video to save',
            saveSuccess: 'Saved successfully',
            saveFailed: 'Save failed, please try again',
            mediaLoadFailed: 'Media failed to load',
            switchSuccess: 'Switched to',
            switchFailed: 'Failed to switch mode',
            networkError: 'Network error, please try again',
            waitForAiReply: 'Please wait for AI reply',
            sendFailed: 'Failed to send, please try again',
            regenerateFailed: 'Failed to regenerate, please try again',
            waitTimeout: 'Wait timeout, please try again',
            audioGenerateSuccess: 'Audio generated successfully',
            conversationNotExist: 'Conversation does not exist',
            audioGenerateFailed: 'Failed to generate audio',
            mediaGenerating: 'Generating...',
            imageGenerating: 'Generating image...',
            videoGenerating: 'Generating video...',
            mediaGenerateFailed: 'Generation failed, please try again',
            mediaNetworkError: 'Network error, please try again',
            heartUnlockSuccess: 'Unlocked successfully',
            heartUnlockFailed: 'Failed to unlock',
        },
    },
    es: {
        // Pestaña de página de chat
        tabChat: 'Chat',
        creation: 'Creación',
        historyRecord: 'Historial',
        dialogueRecord: 'Historial de Diálogo',
        systemPromptEntry: 'Prompt',
        systemPromptTitle: 'Prompt del sistema',
        systemPromptSubtitle: 'Estas instrucciones se proporcionarán primero a la IA en cada conversación.',
        systemPromptPlaceholder: 'Escribe aquí…',
        openSidebar: 'Abrir barra lateral',
        noChat: '¡Aún no has iniciado ninguna conversación~',
        newChat: 'Nuevo chat',
        rename: 'Renombrar',
        changeName: 'Cambiar nombre',
        renameChatTitle: 'Renombrar conversación',
        renameChatPlaceholder: 'Ingresa un nuevo nombre',
        renameSuccess: 'Renombrado correctamente',
        renameFailed: 'Error al renombrar',
        renameChatLimitTip: 'El límite de caracteres es {max}',
        noCreation: 'Sin creaciones',
        newCreation: 'Nueva creación',
        delete: 'Eliminar',
        deleteSuccess: 'Eliminado correctamente',
        deleteFailed: 'Error al eliminar',
        sendFailed: 'Error al enviar, inténtalo de nuevo',
        needSendFirstMessage: 'Por favor, envía el primer mensaje primero',
        loadingMore: 'Cargando más mensajes...',

        // Modal de reducción de diálogos
        reduceDialogueTitle: 'Reducir ventanas de diálogo',
        reduceDialogueSubtitle: 'Se detectaron registros en las ventanas de diálogo. Reducir el número de ventanas eliminará algunos diálogos y sus registros.',
        reduceDialogueSelect: 'Selecciona {count} ventana(s) para cerrar',
        windowName: 'Ventana {index}',
        noRecords: 'Sin registros',
        confirmDelete: 'Confirmar eliminación',

        // Modal de cierre de diálogo
        closeDialogueTitle: 'Cerrar diálogo',
        closeDialogueSubtitle1: 'Cerrar esta ventana eliminará todos los registros de conversación en esta ventana.',
        closeDialogueSubtitle2: 'Esta acción no se puede deshacer. ¿Estás seguro de continuar?',

        // Modal de eliminación de chat
        deleteChatTitle: '¿Eliminar conversación?',
        deleteChatConfirmMessage: 'Después de eliminar, no se conservarán los registros de la conversación actual.',

        // Estado vacío del chat
        emptyGreeting: 'Hola,',
        emptySubtitle1: '¿En qué puedo ayudarte',
        emptySubtitle2: 'hoy?',

        // Acciones de mensaje
        copy: 'Copiar',
        copyText: 'Copiar texto',
        copySuccess: '¡Copiado!',
        cancelEdit: 'Cancelar',
        sendEdit: 'Enviar',
        retry: 'Reintentar',
        clickToResend: 'Haz clic para reenviar',
        insufficientCreditsReply: 'Créditos insuficientes. Por favor recarga para continuar.',
        streamingTimeoutReply: 'Tiempo de respuesta agotado, por favor reintente',
        getMoreCredits: 'Obtener más créditos',

        // Selección de modelo
        switchModel: 'Cambiar modelo',
        model: 'Modelo',
        credits: 'créditos',

        // Operaciones comunes
        edit: 'Editar',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        processing: 'Procesando...',
        saving: 'Guardando...',
        save: 'Guardar',
        enableDialogueModalTitle: 'Consejo',
        enableDialogueModalContent: 'Activa la ventana de diálogo que quieras usar.',
        enableDialogueTip: 'Activar este diálogo',
        disableDialogueTip: 'Desactivar este diálogo',

        // Menú de acciones de mensaje
        startNewChatFromHere: 'Iniciar nuevo chat desde aquí',

        // Relacionado con corazón
        viewHeart: 'Ver corazón',
        heartMoment: 'Momento del corazón',
        unlocking: 'Desbloqueando...',
        unlock: 'Desbloquear',

        // Guía de voz
        voiceGuideText: 'Cuando está activado, las respuestas del personaje se reproducirán automáticamente con voz.',

        // Modal de generación de medios
        imageGeneration: 'Generar Imagen',
        videoGeneration: 'Generar Video',
        imageSubtitle: 'Genera visuales exclusivos basados en la conversación actual',
        videoSubtitle: 'Da vida a las imágenes estáticas, captura momentos en movimiento',
        character: 'Personaje',
        currentCharacter: 'Personaje actual',
        uploadYourPhoto: 'Sube tu foto',
        optional: '(Opcional)',
        imageHint: 'Puedes subir una foto tuya y generaré una foto de ambos basándome en tu apariencia. Si no subes una, generaré una foto individual basada en la conversación actual.',
        videoHint: 'Puedes subir una foto tuya para generar un video dúo con el personaje. Si no subes una, se generará un video individual del personaje.',
        isPublic: 'Hacer público',
        startGenerate: 'Comenzar generación',

        // Modal de resultado de medios
        generatingImage: 'Generando imagen...',
        generatingVideo: 'Generando video...',
        imageGeneratingSubtitle: 'La generación de la foto toma un momento. Una vez completada, enviaré la foto directamente a nuestro chat. Puedes seguir chateando.',
        videoGeneratingSubtitle: 'La generación del video toma un momento. Una vez completada, enviaré el video directamente a nuestro chat. Puedes seguir chateando.',
        continueChat: 'Continuar Chat',
        imageComplete: 'Generación completada',
        videoComplete: 'Generación completada',
        imageCompleteSubtitle: 'Este es nuestro recuerdo exclusivo',
        videoCompleteSubtitle: 'Este es nuestro recuerdo exclusivo',
        saveImage: 'Guardar foto',
        saveVideo: 'Guardar video',
        generateFailed: 'Generación fallida, por favor intenta de nuevo más tarde',
        gotIt: 'Entendido',

        // Entrada de chat
        inputPlaceholder: '¿Qué te gustaría decir?',

        // Modal de editar mensaje
        editMessage: 'Editar mensaje',
        editDialogueTitle: 'Editar mensaje',
        editPlaceholder: 'Por favor ingresa el contenido del mensaje',
        editHint: 'Consejo: Usa () para envolver acciones del personaje, expresiones o descripciones del entorno',

        // Modal de confirmación de retroceso
        rollbackTitle: 'Iniciar nuevo chat desde aquí',
        rollbackMessage: 'Iniciar chat desde aquí eliminará todos los mensajes posteriores. ¿Estás seguro?',

        // Selector de modo
        switchChatMode: 'Cambiar modo de chat',
        subscribe: 'Suscribirse',
        freeUnlimitedChat: 'Chat Ilimitado Gratis',
        vipMemberBanner: 'Hazte VIP y disfruta',
        unlimitedChat: 'Chat ilimitado',
        vipDescription: 'Experiencia doble intensa y relajada',
        vipDescriptionSuffix: 'VIP 0 monedas chat ilimitado, libera toda tu imaginación.',
        vipFree: 'VIP Gratis',
        vipOnly: 'Solo VIP',
        perMessage: '/msg',
        saveChanges: 'Guardar cambios',

        // Lista de mensajes
        messageList: 'Mensajes',
        recent: 'Reciente',
        recentChats: 'Chats recientes',
        loading: 'Cargando...',
        emoji: '[Emoji]',
        image: '[Imagen]',
        audio: '[Audio]',

        // Estado vacío de página de chat
        selectChatToStart: 'Selecciona un chat para comenzar',
        selectFromList: 'Selecciona de la lista o crea una nueva conversación',
        selectChatForDetail: 'Selecciona un chat para ver detalles del personaje',

        // Mensajes toast
        toast: {
            noTopics: 'No hay temas recomendados disponibles',
            getTopicsFailed: 'Error al obtener temas recomendados',
            noMessageToRefresh: 'No hay mensaje para actualizar',
            editSuccess: 'Edición exitosa',
            editFailed: 'Error en la edición',
            operationSuccess: 'Operación exitosa',
            operationFailed: 'Operación fallida',
            selectImageFile: 'Por favor selecciona un archivo de imagen',
            imageSizeLimit: 'El tamaño de la imagen no puede exceder 100MB',
            uploading: 'Subiendo...',
            uploadSuccess: 'Subida exitosa',
            uploadFailed: 'Subida fallida',
            insufficientCoins: 'Monedas insuficientes, por favor recarga',
            noImageToSave: 'No hay imagen para guardar',
            noVideoToSave: 'No hay video para guardar',
            saveSuccess: 'Guardado exitosamente',
            saveFailed: 'Error al guardar, por favor intenta de nuevo',
            mediaLoadFailed: 'Error al cargar el medio',
            switchSuccess: 'Cambiado a',
            switchFailed: 'Error al cambiar modo',
            networkError: 'Error de red, por favor intenta de nuevo',
            waitForAiReply: 'Por favor espera la respuesta de AI',
            sendFailed: 'Error al enviar, por favor intenta de nuevo',
            regenerateFailed: 'Error al regenerar, por favor intenta de nuevo',
            waitTimeout: 'Tiempo de espera agotado, por favor intenta de nuevo',
            audioGenerateSuccess: 'Audio generado exitosamente',
            conversationNotExist: 'La conversación no existe',
            audioGenerateFailed: 'Error al generar audio',
            mediaGenerating: 'Generando...',
            imageGenerating: 'Generando imagen...',
            videoGenerating: 'Generando video...',
            mediaGenerateFailed: 'Generación fallida, inténtalo de nuevo',
            mediaNetworkError: 'Error de red, inténtalo de nuevo',
            heartUnlockSuccess: 'Desbloqueado con éxito',
            heartUnlockFailed: 'Fallo al desbloquear',
        },
    },
    fr: {
        // Onglet de page de chat
        tabChat: 'Chat',
        creation: 'Création',
        historyRecord: 'Historique',
        dialogueRecord: 'Historique des Dialogues',
        systemPromptEntry: 'Prompt',
        systemPromptTitle: 'Prompt système',
        systemPromptSubtitle: 'Ces instructions seront fournies en priorité à l’IA à chaque conversation.',
        systemPromptPlaceholder: 'Saisissez ici…',
        openSidebar: 'Ouvrir la barre latérale',
        noChat: "Vous n'avez pas encore commencé de conversation~",
        newChat: 'Nouvelle conversation',
        rename: 'Renommer',
        changeName: 'Modifier le nom',
        renameChatTitle: 'Renommer la conversation',
        renameChatPlaceholder: 'Veuillez saisir un nouveau nom',
        renameSuccess: 'Renommé avec succès',
        renameFailed: 'Échec du renommage',
        renameChatLimitTip: 'La limite de caractères est de {max}',
        noCreation: 'Pas de création',
        newCreation: 'Nouvelle création',
        delete: 'Supprimer',
        deleteSuccess: 'Supprimé avec succès',
        deleteFailed: 'Échec de la suppression',
        sendFailed: 'Échec de l\'envoi, veuillez réessayer',
        needSendFirstMessage: 'Veuillez d\'abord envoyer le premier message',
        loadingMore: 'Chargement de plus de messages...',

        // Modal de réduction des dialogues
        reduceDialogueTitle: 'Réduire les fenêtres de dialogue',
        reduceDialogueSubtitle: 'Des enregistrements ont été détectés dans les fenêtres de dialogue. Réduire le nombre de fenêtres supprimera certains dialogues et leurs enregistrements.',
        reduceDialogueSelect: 'Sélectionnez {count} fenêtre(s) à fermer',
        windowName: 'Fenêtre {index}',
        noRecords: 'Aucun enregistrement',
        confirmDelete: 'Confirmer la suppression',

        // Modal de fermeture de dialogue
        closeDialogueTitle: 'Fermer le dialogue',
        closeDialogueSubtitle1: 'Fermer cette fenêtre supprimera tous les enregistrements de conversation dans cette fenêtre.',
        closeDialogueSubtitle2: 'Cette action ne peut pas être annulée. Êtes-vous sûr de vouloir continuer?',

        // Modal de suppression de chat
        deleteChatTitle: 'Supprimer la conversation ?',
        deleteChatConfirmMessage: 'Après suppression, les enregistrements de la conversation actuelle ne seront pas conservés.',

        // État vide du chat
        emptyGreeting: 'Bonjour,',
        emptySubtitle1: 'Comment puis-je vous aider',
        emptySubtitle2: 'aujourd\'hui?',

        // Actions de message
        copy: 'Copier',
        copyText: 'Copier le texte',
        copySuccess: 'Copié!',
        cancelEdit: 'Annuler',
        sendEdit: 'Envoyer',
        retry: 'Réessayer',
        clickToResend: 'Cliquez pour renvoyer',
        insufficientCreditsReply: 'Crédits insuffisants. Veuillez recharger pour continuer.',
        streamingTimeoutReply: 'Délai de réponse dépassé, veuillez réessayer',
        getMoreCredits: 'Obtenir plus de crédits',

        // Sélection de modèle
        switchModel: 'Changer de modèle',
        model: 'Modèle',
        credits: 'crédits',

        // Opérations communes
        edit: 'Modifier',
        cancel: 'Annuler',
        confirm: 'Confirmer',
        processing: 'Traitement...',
        saving: 'Enregistrement...',
        save: 'Sauvegarder',
        enableDialogueModalTitle: 'Astuce',
        enableDialogueModalContent: 'Veuillez activer la fenêtre de dialogue que vous souhaitez utiliser.',
        enableDialogueTip: 'Activer ce dialogue',
        disableDialogueTip: 'Désactiver ce dialogue',

        // Menu d\'actions de message
        startNewChatFromHere: 'Démarrer une nouvelle conversation ici',

        // Lié au cœur
        viewHeart: 'Voir le cœur',
        heartMoment: 'Moment du cœur',
        unlocking: 'Déverrouillage...',
        unlock: 'Déverrouiller',

        // Guide vocal
        voiceGuideText: 'Lorsqu\'activé, les réponses du personnage seront automatiquement lues à voix haute.',

        // Modal de génération de médias
        imageGeneration: 'Générer une image',
        videoGeneration: 'Générer une vidéo',
        imageSubtitle: 'Générez des visuels exclusifs basés sur la conversation actuelle',
        videoSubtitle: 'Donnez vie aux images fixes, capturez des moments en mouvement',
        character: 'Personnage',
        currentCharacter: 'Personnage actuel',
        uploadYourPhoto: 'Téléchargez votre photo',
        optional: '(Optionnel)',
        imageHint: 'Vous pouvez télécharger une photo de vous, et je générerai une photo de nous deux basée sur votre apparence. Si non téléchargée, je générerai une photo solo basée sur la conversation actuelle.',
        videoHint: 'Vous pouvez télécharger une photo de vous pour générer une vidéo duo avec le personnage. Si non téléchargée, une vidéo solo du personnage sera générée.',
        isPublic: 'Rendre public',
        startGenerate: 'Démarrer la génération',

        // Modal de résultat de médias
        generatingImage: 'Génération de l\'image...',
        generatingVideo: 'Génération de la vidéo...',
        imageGeneratingSubtitle: 'La génération de la photo prend un moment. Une fois terminée, je l\'enverrai directement dans notre chat. Vous pouvez continuer à discuter.',
        videoGeneratingSubtitle: 'La génération de la vidéo prend un moment. Une fois terminée, je l\'enverrai directement dans notre chat. Vous pouvez continuer à discuter.',
        continueChat: 'Continuer le chat',
        imageComplete: 'Génération terminée',
        videoComplete: 'Génération terminée',
        imageCompleteSubtitle: 'C\'est notre souvenir exclusif',
        videoCompleteSubtitle: 'C\'est notre souvenir exclusif',
        saveImage: 'Enregistrer la photo',
        saveVideo: 'Enregistrer la vidéo',
        generateFailed: 'Génération échouée, veuillez réessayer plus tard',
        gotIt: 'Compris',

        // Entrée de chat
        inputPlaceholder: 'Que voulez-vous dire',

        // Modal de modification de message
        editMessage: 'Modifier le message',
        editDialogueTitle: 'Modifier le message',
        editPlaceholder: 'Veuillez entrer le contenu du message',
        editHint: 'Conseil: Utilisez () pour envelopper les actions du personnage, les expressions ou les descriptions de l\'environnement',

        // Modal de confirmation de retour
        rollbackTitle: 'Démarrer une nouvelle conversation ici',
        rollbackMessage: 'Démarrer la conversation ici supprimera tous les messages suivants. Êtes-vous sûr?',

        // Sélecteur de mode
        switchChatMode: 'Changer le mode de chat',
        subscribe: "S'abonner",
        freeUnlimitedChat: 'Chat Illimité Gratuit',
        vipMemberBanner: 'Devenez VIP et profitez',
        unlimitedChat: 'Chat illimité',
        vipDescription: 'Double expérience intense et relaxante',
        vipDescriptionSuffix: 'VIP 0 pièce chat illimité, libérez toute votre imagination.',
        vipFree: 'VIP Gratuit',
        vipOnly: 'VIP uniquement',
        perMessage: '/msg',
        saveChanges: 'Enregistrer les modifications',

        // Liste des messages
        messageList: 'Messages',
        recent: 'Récent',
        recentChats: 'Chats récents',
        loading: 'Chargement...',
        emoji: '[Emoji]',
        image: '[Image]',
        audio: '[Audio]',

        // État vide de la page de chat
        selectChatToStart: 'Sélectionnez un chat pour commencer',
        selectFromList: 'Sélectionnez dans la liste ou créez une nouvelle conversation',
        selectChatForDetail: 'Sélectionnez un chat pour voir les détails du personnage',

        // Messages toast
        toast: {
            noTopics: 'Aucun sujet recommandé disponible',
            getTopicsFailed: 'Échec de récupération des sujets recommandés',
            noMessageToRefresh: 'Aucun message à actualiser',
            editSuccess: 'Modification réussie',
            editFailed: 'Échec de la modification',
            operationSuccess: 'Opération réussie',
            operationFailed: 'Opération échouée',
            selectImageFile: 'Veuillez sélectionner un fichier image',
            imageSizeLimit: 'La taille de l\'image ne peut pas dépasser 100Mo',
            uploading: 'Téléchargement...',
            uploadSuccess: 'Téléchargement réussi',
            uploadFailed: 'Échec du téléchargement',
            insufficientCoins: 'Pièces insuffisantes, veuillez recharger',
            noImageToSave: 'Aucune image à enregistrer',
            noVideoToSave: 'Aucune vidéo à enregistrer',
            saveSuccess: 'Enregistré avec succès',
            saveFailed: 'Échec de l\'enregistrement, veuillez réessayer',
            mediaLoadFailed: 'Échec du chargement du média',
            switchSuccess: 'Changé vers',
            switchFailed: 'Échec du changement de mode',
            networkError: 'Erreur réseau, veuillez réessayer',
            waitForAiReply: 'Veuillez attendre la réponse de l\'IA',
            sendFailed: 'Échec de l\'envoi, veuillez réessayer',
            regenerateFailed: 'Échec de la régénération, veuillez réessayer',
            waitTimeout: 'Délai d\'attente expiré, veuillez réessayer',
            audioGenerateSuccess: 'Audio généré avec succès',
            conversationNotExist: 'La conversation n\'existe pas',
            audioGenerateFailed: 'Échec de la génération audio',
            mediaGenerating: 'Génération en cours...',
            imageGenerating: 'Génération de l\'image...',
            videoGenerating: 'Génération de la vidéo...',
            mediaGenerateFailed: 'Échec de la génération, réessayez',
            mediaNetworkError: 'Erreur réseau, réessayez',
            heartUnlockSuccess: 'Déverrouillage réussi',
            heartUnlockFailed: 'Échec du déverrouillage',
        },
    },
    de: {
        // Chat-Seiten-Tab
        tabChat: 'Chat',
        creation: 'Kreation',
        historyRecord: 'Verlauf',
        dialogueRecord: 'Dialogverlauf',
        systemPromptEntry: 'Prompt',
        systemPromptTitle: 'System-Prompt',
        systemPromptSubtitle: 'Diese Anweisungen werden der KI in jedem Gespräch vorrangig bereitgestellt.',
        systemPromptPlaceholder: 'Hier eingeben…',
        openSidebar: 'Seitenleiste öffnen',
        noChat: 'Du hast noch kein Gespräch begonnen~',
        newChat: 'Neuer Chat',
        rename: 'Umbenennen',
        changeName: 'Namen ändern',
        renameChatTitle: 'Konversation umbenennen',
        renameChatPlaceholder: 'Bitte einen neuen Namen eingeben',
        renameSuccess: 'Erfolgreich umbenannt',
        renameFailed: 'Umbenennen fehlgeschlagen',
        renameChatLimitTip: 'Zeichenlimit: {max}',
        noCreation: 'Keine Kreationen',
        newCreation: 'Neue Kreation',
        delete: 'Löschen',
        deleteSuccess: 'Erfolgreich gelöscht',
        deleteFailed: 'Löschen fehlgeschlagen',
        sendFailed: 'Senden fehlgeschlagen, bitte erneut versuchen',
        needSendFirstMessage: 'Bitte senden Sie zuerst die erste Nachricht',
        loadingMore: 'Weitere Nachrichten werden geladen...',

        // Dialog-Reduzierungs-Modal
        reduceDialogueTitle: 'Dialogfenster reduzieren',
        reduceDialogueSubtitle: 'Aufzeichnungen in Dialogfenstern erkannt. Das Reduzieren der Fensteranzahl entfernt einige Dialoge und deren Aufzeichnungen.',
        reduceDialogueSelect: 'Bitte wählen Sie {count} Fenster zum Schließen',
        windowName: 'Fenster {index}',
        noRecords: 'Keine Aufzeichnungen',
        confirmDelete: 'Löschen bestätigen',

        // Dialog-Schließ-Modal
        closeDialogueTitle: 'Dialog schließen',
        closeDialogueSubtitle1: 'Das Schließen dieses Fensters löscht alle Gesprächsaufzeichnungen in diesem Fenster.',
        closeDialogueSubtitle2: 'Diese Aktion kann nicht rückgängig gemacht werden. Sind Sie sicher, dass Sie fortfahren möchten?',

        // Chat-Lösch-Modal
        deleteChatTitle: 'Konversation löschen?',
        deleteChatConfirmMessage: 'Nach dem Löschen werden die aktuellen Gesprächsaufzeichnungen nicht beibehalten.',

        // Leerer Chat-Zustand
        emptyGreeting: 'Hallo,',
        emptySubtitle1: 'Wie kann ich Ihnen heute',
        emptySubtitle2: 'helfen?',

        // Nachrichtenaktionen
        copy: 'Kopieren',
        copyText: 'Text kopieren',
        copySuccess: 'Kopiert!',
        cancelEdit: 'Abbrechen',
        sendEdit: 'Senden',
        retry: 'Erneut versuchen',
        clickToResend: 'Klicken zum erneuten Senden',
        insufficientCreditsReply: 'Unzureichendes Guthaben. Bitte aufladen, um fortzufahren.',
        streamingTimeoutReply: 'Zeitüberschreitung bei der Antwort, bitte erneut versuchen',
        getMoreCredits: 'Mehr Guthaben erhalten',

        // Modellauswahl
        switchModel: 'Modell wechseln',
        model: 'Modell',
        credits: 'Guthaben',

        // Gemeinsame Operationen
        edit: 'Bearbeiten',
        cancel: 'Abbrechen',
        confirm: 'Bestätigen',
        processing: 'Verarbeitung...',
        saving: 'Speichern...',
        save: 'Speichern',
        enableDialogueModalTitle: 'Hinweis',
        enableDialogueModalContent: 'Bitte aktiviere das Dialogfenster, das du verwenden möchtest.',
        enableDialogueTip: 'Diesen Dialog aktivieren',
        disableDialogueTip: 'Diesen Dialog deaktivieren',

        // Nachrichtenaktionsmenü
        startNewChatFromHere: 'Neuen Chat von hier starten',

        // Herz bezogen
        viewHeart: 'Herz anzeigen',
        heartMoment: 'Herzmoment',
        unlocking: 'Entsperren...',
        unlock: 'Entsperren',

        // Sprachführung
        voiceGuideText: 'Wenn aktiviert, werden Charakterantworten automatisch als Sprache abgespielt.',

        // Mediengenerierungs-Modal
        imageGeneration: 'Bild generieren',
        videoGeneration: 'Video generieren',
        imageSubtitle: 'Erstellen Sie exklusive Bilder basierend auf dem aktuellen Gespräch',
        videoSubtitle: 'Erwecken Sie Standbilder zum Leben, halten Sie fließende Momente fest',
        character: 'Charakter',
        currentCharacter: 'Aktueller Charakter',
        uploadYourPhoto: 'Laden Sie Ihr Foto hoch',
        optional: '(Optional)',
        imageHint: 'Sie können ein Foto von sich hochladen, und ich werde basierend auf Ihrem Aussehen ein Foto von uns beiden erstellen. Wenn nicht hochgeladen, werde ich ein Solo-Foto basierend auf dem aktuellen Gespräch erstellen.',
        videoHint: 'Sie können ein Foto von sich hochladen, um ein Duo-Video mit dem Charakter zu erstellen. Wenn nicht hochgeladen, wird ein Solo-Charakter-Video erstellt.',
        isPublic: 'Öffentlich machen',
        startGenerate: 'Generierung starten',

        // Medienergebnis-Modal
        generatingImage: 'Bild wird generiert...',
        generatingVideo: 'Video wird generiert...',
        imageGeneratingSubtitle: 'Die Bildgenerierung dauert einen Moment. Sobald sie abgeschlossen ist, sende ich das Foto direkt in unseren Chat. Sie können gerne weiter chatten.',
        videoGeneratingSubtitle: 'Die Videogenerierung dauert einen Moment. Sobald sie abgeschlossen ist, sende ich das Video direkt in unseren Chat. Sie können gerne weiter chatten.',
        continueChat: 'Chat fortsetzen',
        imageComplete: 'Generierung abgeschlossen',
        videoComplete: 'Generierung abgeschlossen',
        imageCompleteSubtitle: 'Dies ist unsere exklusive Erinnerung',
        videoCompleteSubtitle: 'Dies ist unsere exklusive Erinnerung',
        saveImage: 'Foto speichern',
        saveVideo: 'Video speichern',
        generateFailed: 'Generierung fehlgeschlagen, bitte später erneut versuchen',
        gotIt: 'Verstanden',

        // Chat-Eingabe
        inputPlaceholder: 'Was möchten Sie sagen',

        // Nachricht bearbeiten Modal
        editMessage: 'Nachricht bearbeiten',
        editDialogueTitle: 'Nachricht bearbeiten',
        editPlaceholder: 'Bitte geben Sie den Nachrichteninhalt ein',
        editHint: 'Tipp: Verwenden Sie (), um Charakteraktionen, Ausdrücke oder Umgebungsbeschreibungen zu umschließen',

        // Rollback-Bestätigungs-Modal
        rollbackTitle: 'Neuen Chat von hier starten',
        rollbackMessage: 'Das Starten des Chats von hier löscht alle nachfolgenden Nachrichten. Sind Sie sicher?',

        // Modusauswahl
        switchChatMode: 'Chat-Modus wechseln',
        subscribe: 'Abonnieren',
        freeUnlimitedChat: 'Kostenloser Unbegrenzter Chat',
        vipMemberBanner: 'Werden Sie VIP und genießen Sie',
        unlimitedChat: 'Unbegrenzten Chat',
        vipDescription: 'Intensive & entspannte Doppelerfahrung',
        vipDescriptionSuffix: 'VIP 0 Münzen unbegrenzter Chat, entfesseln Sie Ihre Fantasie.',
        vipFree: 'VIP Kostenlos',
        vipOnly: 'Nur VIP',
        perMessage: '/Msg',
        saveChanges: 'Änderungen speichern',

        // Nachrichtenliste
        messageList: 'Nachrichten',
        recent: 'Kürzlich',
        recentChats: 'Kürzliche Chats',
        loading: 'Laden...',
        emoji: '[Emoji]',
        image: '[Bild]',
        audio: '[Audio]',

        // Chat-Seite Leerzustand
        selectChatToStart: 'Wählen Sie einen Chat zum Starten',
        selectFromList: 'Aus der Liste auswählen oder neue Unterhaltung erstellen',
        selectChatForDetail: 'Chat auswählen für Charakterdetails',

        // Toast-Nachrichten
        toast: {
            noTopics: 'Keine empfohlenen Themen verfügbar',
            getTopicsFailed: 'Empfohlene Themen konnten nicht abgerufen werden',
            noMessageToRefresh: 'Keine Nachricht zum Aktualisieren',
            editSuccess: 'Bearbeitung erfolgreich',
            editFailed: 'Bearbeitung fehlgeschlagen',
            operationSuccess: 'Operation erfolgreich',
            operationFailed: 'Operation fehlgeschlagen',
            selectImageFile: 'Bitte wählen Sie eine Bilddatei',
            imageSizeLimit: 'Bildgröße darf 100MB nicht überschreiten',
            uploading: 'Hochladen...',
            uploadSuccess: 'Upload erfolgreich',
            uploadFailed: 'Upload fehlgeschlagen',
            insufficientCoins: 'Unzureichende Münzen, bitte aufladen',
            noImageToSave: 'Kein Bild zum Speichern',
            noVideoToSave: 'Kein Video zum Speichern',
            saveSuccess: 'Erfolgreich gespeichert',
            saveFailed: 'Speichern fehlgeschlagen, bitte erneut versuchen',
            mediaLoadFailed: 'Medien konnten nicht geladen werden',
            switchSuccess: 'Gewechselt zu',
            switchFailed: 'Moduswechsel fehlgeschlagen',
            networkError: 'Netzwerkfehler, bitte erneut versuchen',
            waitForAiReply: 'Bitte warten Sie auf die AI-Antwort',
            sendFailed: 'Senden fehlgeschlagen, bitte erneut versuchen',
            regenerateFailed: 'Regenerierung fehlgeschlagen, bitte erneut versuchen',
            waitTimeout: 'Wartezeit abgelaufen, bitte erneut versuchen',
            audioGenerateSuccess: 'Audio erfolgreich generiert',
            conversationNotExist: 'Konversation existiert nicht',
            audioGenerateFailed: 'Audio-Generierung fehlgeschlagen',
            mediaGenerating: 'Wird generiert...',
            imageGenerating: 'Bild wird generiert...',
            videoGenerating: 'Video wird generiert...',
            mediaGenerateFailed: 'Generierung fehlgeschlagen, bitte erneut versuchen',
            mediaNetworkError: 'Netzwerkfehler, bitte erneut versuchen',
            heartUnlockSuccess: 'Erfolgreich entsperrt',
            heartUnlockFailed: 'Entsperren fehlgeschlagen',
        },
    },
    ru: {
        // Вкладка страницы чата
        tabChat: 'Чат',
        creation: 'Создание',
        historyRecord: 'История',
        dialogueRecord: 'История Диалогов',
        systemPromptEntry: 'Промпт',
        systemPromptTitle: 'Системный промпт',
        systemPromptSubtitle: 'Эти инструкции будут в приоритетном порядке передаваться ИИ в каждом диалоге.',
        systemPromptPlaceholder: 'Введите здесь…',
        openSidebar: 'Открыть боковую панель',
        noChat: 'Вы еще не начали ни одного разговора~',
        newChat: 'Новый чат',
        rename: 'Переименовать',
        changeName: 'Изменить имя',
        renameChatTitle: 'Переименовать диалог',
        renameChatPlaceholder: 'Введите новое имя',
        renameSuccess: 'Переименовано успешно',
        renameFailed: 'Ошибка переименования',
        renameChatLimitTip: 'Лимит символов: {max}',
        noCreation: 'Нет творений',
        newCreation: 'Новое творение',
        delete: 'Удалить',
        deleteSuccess: 'Успешно удалено',
        deleteFailed: 'Ошибка удаления',
        sendFailed: 'Ошибка отправки, попробуйте снова',
        needSendFirstMessage: 'Пожалуйста, сначала отправьте первое сообщение',
        loadingMore: 'Загрузка сообщений...',

        // Модал уменьшения диалогов
        reduceDialogueTitle: 'Уменьшить диалоговые окна',
        reduceDialogueSubtitle: 'Обнаружены записи в диалоговых окнах. Уменьшение количества окон удалит некоторые диалоги и их записи.',
        reduceDialogueSelect: 'Выберите {count} окно(а) для закрытия',
        windowName: 'Окно {index}',
        noRecords: 'Нет записей',
        confirmDelete: 'Подтвердить удаление',

        // Модал закрытия диалога
        closeDialogueTitle: 'Закрыть диалог',
        closeDialogueSubtitle1: 'Закрытие этого окна удалит все записи разговоров в этом окне.',
        closeDialogueSubtitle2: 'Это действие нельзя отменить. Вы уверены, что хотите продолжить?',

        // Модал удаления чата
        deleteChatTitle: 'Удалить диалог?',
        deleteChatConfirmMessage: 'После удаления текущие записи диалога не будут сохранены.',

        // Пустое состояние чата
        emptyGreeting: 'Привет,',
        emptySubtitle1: 'Чем я могу вам помочь',
        emptySubtitle2: 'сегодня?',

        // Действия с сообщениями
        copy: 'Копировать',
        copyText: 'Копировать текст',
        copySuccess: 'Скопировано!',
        cancelEdit: 'Отмена',
        sendEdit: 'Отправить',
        retry: 'Повторить',
        clickToResend: 'Нажмите для повторной отправки',
        insufficientCreditsReply: 'Недостаточно кредитов. Пожалуйста, пополните для продолжения.',
        streamingTimeoutReply: 'Время ожидания ответа истекло, повторите попытку',
        getMoreCredits: 'Получить больше кредитов',

        // Выбор модели
        switchModel: 'Сменить модель',
        model: 'Модель',
        credits: 'кредитов',

        // Общие операции
        edit: 'Редактировать',
        cancel: 'Отмена',
        confirm: 'Подтвердить',
        processing: 'Обработка...',
        saving: 'Сохранение...',
        save: 'Сохранить',
        enableDialogueModalTitle: 'Подсказка',
        enableDialogueModalContent: 'Пожалуйста, включите диалоговое окно, которое вы хотите использовать.',
        enableDialogueTip: 'Включить этот диалог',
        disableDialogueTip: 'Отключить этот диалог',

        // Меню действий сообщения
        startNewChatFromHere: 'Начать новый чат отсюда',

        // Связанное с сердцем
        viewHeart: 'Посмотреть сердце',
        heartMoment: 'Момент сердца',
        unlocking: 'Разблокировка...',
        unlock: 'Разблокировать',

        // Голосовой гид
        voiceGuideText: 'При включении ответы персонажа будут автоматически воспроизводиться голосом.',

        // Модальное окно генерации медиа
        imageGeneration: 'Создать изображение',
        videoGeneration: 'Создать видео',
        imageSubtitle: 'Создание эксклюзивных изображений на основе текущего диалога',
        videoSubtitle: 'Оживите статичные изображения, запечатлейте движущиеся моменты',
        character: 'Персонаж',
        currentCharacter: 'Текущий персонаж',
        uploadYourPhoto: 'Загрузите свою фотографию',
        optional: '(Необязательно)',
        imageHint: 'Вы можете загрузить свою фотографию, и я создам фотографию нас обоих на основе вашей внешности. Если не загружено, я создам сольную фотографию на основе текущего разговора.',
        videoHint: 'Вы можете загрузить свою фотографию для создания дуэтного видео с персонажем. Если не загружено, будет создано сольное видео персонажа.',
        isPublic: 'Сделать публичным',
        startGenerate: 'Начать генерацию',

        // Модальное окно результата медиа
        generatingImage: 'Создание изображения...',
        generatingVideo: 'Создание видео...',
        imageGeneratingSubtitle: 'Создание фото займет некоторое время. Как только оно будет готово, я отправлю его прямо в чат. Можете продолжать общение.',
        videoGeneratingSubtitle: 'Создание видео займет некоторое время. Как только оно будет готово, я отправлю его прямо в чат. Можете продолжать общение.',
        continueChat: 'Продолжить чат',
        imageComplete: 'Готово',
        videoComplete: 'Готово',
        imageCompleteSubtitle: 'Это наше эксклюзивное воспоминание',
        videoCompleteSubtitle: 'Это наше эксклюзивное воспоминание',
        saveImage: 'Сохранить фото',
        saveVideo: 'Сохранить видео',
        generateFailed: 'Генерация не удалась, попробуйте позже',
        gotIt: 'Понятно',

        // Ввод чата
        inputPlaceholder: 'Что вы хотите сказать',

        // Модальное окно редактирования сообщения
        editMessage: 'Редактировать сообщение',
        editDialogueTitle: 'Редактировать сообщение',
        editPlaceholder: 'Пожалуйста, введите содержание сообщения',
        editHint: 'Совет: Используйте () для обрамления действий персонажа, выражений или описаний окружения',

        // Модальное окно подтверждения отката
        rollbackTitle: 'Начать новый чат отсюда',
        rollbackMessage: 'Начало чата отсюда удалит все последующие сообщения. Вы уверены?',

        // Выбор режима
        switchChatMode: 'Переключить режим чата',
        subscribe: 'Подписаться',
        freeUnlimitedChat: 'Бесплатный Безлимитный Чат',
        vipMemberBanner: 'Станьте VIP и наслаждайтесь',
        unlimitedChat: 'Безлимитным чатом',
        vipDescription: 'Двойной опыт: интенсив и релакс',
        vipDescriptionSuffix: 'VIP 0 монет безлимитный чат, раскройте свое воображение.',
        vipFree: 'VIP Бесплатно',
        vipOnly: 'Только VIP',
        perMessage: '/сообщ',
        saveChanges: 'Сохранить изменения',

        // Список сообщений
        messageList: 'Сообщения',
        recent: 'Недавние',
        recentChats: 'Недавние чаты',
        loading: 'Загрузка...',
        emoji: '[Эмодзи]',
        image: '[Изображение]',
        audio: '[Аудио]',

        // Пустое состояние страницы чата
        selectChatToStart: 'Выберите чат для начала',
        selectFromList: 'Выберите из списка или создайте новый разговор',
        selectChatForDetail: 'Выберите чат для просмотра деталей персонажа',

        // Тост-сообщения
        toast: {
            noTopics: 'Нет доступных рекомендованных тем',
            getTopicsFailed: 'Не удалось получить рекомендованные темы',
            noMessageToRefresh: 'Нет сообщения для обновления',
            editSuccess: 'Редактирование успешно',
            editFailed: 'Ошибка редактирования',
            operationSuccess: 'Операция успешна',
            operationFailed: 'Операция не удалась',
            selectImageFile: 'Пожалуйста, выберите файл изображения',
            imageSizeLimit: 'Размер изображения не может превышать 100МБ',
            uploading: 'Загрузка...',
            uploadSuccess: 'Загрузка успешна',
            uploadFailed: 'Загрузка не удалась',
            insufficientCoins: 'Недостаточно монет, пожалуйста, пополните',
            noImageToSave: 'Нет изображения для сохранения',
            noVideoToSave: 'Нет видео для сохранения',
            saveSuccess: 'Успешно сохранено',
            saveFailed: 'Сохранение не удалось, попробуйте снова',
            mediaLoadFailed: 'Не удалось загрузить медиа',
            switchSuccess: 'Переключено на',
            switchFailed: 'Не удалось переключить режим',
            networkError: 'Ошибка сети, попробуйте снова',
            waitForAiReply: 'Пожалуйста, дождитесь ответа ИИ',
            sendFailed: 'Отправка не удалась, попробуйте снова',
            regenerateFailed: 'Регенерация не удалась, попробуйте снова',
            waitTimeout: 'Время ожидания истекло, попробуйте снова',
            audioGenerateSuccess: 'Аудио успешно сгенерировано',
            conversationNotExist: 'Разговор не существует',
            audioGenerateFailed: 'Не удалось сгенерировать аудио',
            mediaGenerating: 'Генерация...',
            imageGenerating: 'Генерация изображения...',
            videoGenerating: 'Генерация видео...',
            mediaGenerateFailed: 'Ошибка генерации, попробуйте снова',
            mediaNetworkError: 'Ошибка сети, попробуйте снова',
            heartUnlockSuccess: 'Разблокировано успешно',
            heartUnlockFailed: 'Не удалось разблокировать',
        },
    },
    pt: {
        // Aba da página de chat
        tabChat: 'Chat',
        creation: 'Criação',
        historyRecord: 'Histórico',
        dialogueRecord: 'Histórico de Diálogos',
        systemPromptEntry: 'Prompt',
        systemPromptTitle: 'Prompt do sistema',
        systemPromptSubtitle: 'Estas instruções serão fornecidas primeiro à IA em cada conversa.',
        systemPromptPlaceholder: 'Digite aqui…',
        openSidebar: 'Abrir barra lateral',
        noChat: 'Você ainda não iniciou nenhuma conversa~',
        newChat: 'Nova conversa',
        rename: 'Renomear',
        changeName: 'Alterar nome',
        renameChatTitle: 'Renomear conversa',
        renameChatPlaceholder: 'Insira um novo nome',
        renameSuccess: 'Renomeado com sucesso',
        renameFailed: 'Falha ao renomear',
        renameChatLimitTip: 'Limite de caracteres: {max}',
        noCreation: 'Sem criações',
        newCreation: 'Nova criação',
        delete: 'Excluir',
        deleteSuccess: 'Excluído com sucesso',
        deleteFailed: 'Falha ao excluir',
        sendFailed: 'Falha ao enviar, tente novamente',
        needSendFirstMessage: 'Por favor, envie a primeira mensagem primeiro',
        loadingMore: 'Carregando mais mensagens...',

        // Modal de redução de diálogos
        reduceDialogueTitle: 'Reduzir janelas de diálogo',
        reduceDialogueSubtitle: 'Registros detectados nas janelas de diálogo. Reduzir o número de janelas removerá alguns diálogos e seus registros.',
        reduceDialogueSelect: 'Selecione {count} janela(s) para fechar',
        windowName: 'Janela {index}',
        noRecords: 'Sem registros',
        confirmDelete: 'Confirmar exclusão',

        // Modal de fechamento de diálogo
        closeDialogueTitle: 'Fechar diálogo',
        closeDialogueSubtitle1: 'Fechar esta janela excluirá todos os registros de conversa nesta janela.',
        closeDialogueSubtitle2: 'Esta ação não pode ser desfeita. Tem certeza de que deseja continuar?',

        // Modal de exclusão de chat
        deleteChatTitle: 'Excluir conversa?',
        deleteChatConfirmMessage: 'Após excluir, os registros da conversa atual não serão mantidos.',

        // Estado vazio do chat
        emptyGreeting: 'Olá,',
        emptySubtitle1: 'Como posso ajudá-lo',
        emptySubtitle2: 'hoje?',

        // Ações de mensagem
        copy: 'Copiar',
        copyText: 'Copiar texto',
        copySuccess: 'Copiado!',
        cancelEdit: 'Cancelar',
        sendEdit: 'Enviar',
        retry: 'Tentar novamente',
        clickToResend: 'Clique para reenviar',
        insufficientCreditsReply: 'Créditos insuficientes. Por favor, recarregue para continuar.',
        streamingTimeoutReply: 'Tempo de resposta esgotado, tente novamente',
        getMoreCredits: 'Obter mais créditos',

        // Seleção de modelo
        switchModel: 'Trocar modelo',
        model: 'Modelo',
        credits: 'créditos',

        // Operações comuns
        edit: 'Editar',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        processing: 'Processando...',
        saving: 'Salvando...',
        save: 'Salvar',
        enableDialogueModalTitle: 'Dica',
        enableDialogueModalContent: 'Ative a janela de diálogo que você deseja usar.',
        enableDialogueTip: 'Ativar este diálogo',
        disableDialogueTip: 'Desativar este diálogo',

        // Menu de ações de mensagem
        startNewChatFromHere: 'Iniciar novo chat daqui',

        // Relacionado ao coração
        viewHeart: 'Ver coração',
        heartMoment: 'Momento do coração',
        unlocking: 'Desbloqueando...',
        unlock: 'Desbloquear',

        // Guia de voz
        voiceGuideText: 'Quando ativado, as respostas do personagem serão automaticamente reproduzidas em voz.',

        // Modal de geração de mídia
        imageGeneration: 'Gerar Imagem',
        videoGeneration: 'Gerar Vídeo',
        imageSubtitle: 'Gere visuais exclusivos com base na conversa atual',
        videoSubtitle: 'Dê vida a imagens estáticas, capture momentos em movimento',
        character: 'Personagem',
        currentCharacter: 'Personagem atual',
        uploadYourPhoto: 'Envie sua foto',
        optional: '(Opcional)',
        imageHint: 'Você pode enviar uma foto sua, e eu gerarei uma foto de nós dois com base na sua aparência. Se não enviar, gerarei uma foto solo baseada na conversa atual.',
        videoHint: 'Você pode enviar uma foto sua para gerar um vídeo duo com o personagem. Se não enviar, será gerado um vídeo solo do personagem.',
        isPublic: 'Tornar público',
        startGenerate: 'Iniciar geração',

        // Modal de resultado de mídia
        generatingImage: 'Gerando imagem...',
        generatingVideo: 'Gerando vídeo...',
        imageGeneratingSubtitle: 'A geração da foto leva um momento. Assim que estiver concluída, enviarei a foto diretamente para o nosso chat. Sinta-se à vontade para continuar conversando.',
        videoGeneratingSubtitle: 'A geração do vídeo leva um momento. Assim que estiver concluída, enviarei o vídeo diretamente para o nosso chat. Sinta-se à vontade para continuar conversando.',
        continueChat: 'Continuar Chat',
        imageComplete: 'Geração Concluída',
        videoComplete: 'Geração Concluída',
        imageCompleteSubtitle: 'Esta é a nossa memória exclusiva',
        videoCompleteSubtitle: 'Esta é a nossa memória exclusiva',
        saveImage: 'Salvar foto',
        saveVideo: 'Salvar vídeo',
        generateFailed: 'Geração falhou, por favor tente novamente mais tarde',
        gotIt: 'Entendi',

        // Entrada de chat
        inputPlaceholder: 'O que você gostaria de dizer',

        // Modal de edição de mensagem
        editMessage: 'Editar mensagem',
        editDialogueTitle: 'Editar mensagem',
        editPlaceholder: 'Por favor, insira o conteúdo da mensagem',
        editHint: 'Dica: Use () para envolver ações do personagem, expressões ou descrições do ambiente',

        // Modal de confirmação de rollback
        rollbackTitle: 'Iniciar novo chat daqui',
        rollbackMessage: 'Iniciar o chat daqui excluirá todas as mensagens subsequentes. Tem certeza?',

        // Seletor de modo
        switchChatMode: 'Mudar modo de chat',
        subscribe: 'Assinar',
        freeUnlimitedChat: 'Chat Ilimitado Grátis',
        vipMemberBanner: 'Torne-se VIP e aproveite',
        unlimitedChat: 'Chat ilimitado',
        vipDescription: 'Experiência dupla intensa e relaxante',
        vipDescriptionSuffix: 'VIP 0 moedas chat ilimitado, liberte sua imaginação.',
        vipFree: 'VIP Grátis',
        vipOnly: 'Apenas VIP',
        perMessage: '/msg',
        saveChanges: 'Salvar alterações',

        // Lista de mensagens
        messageList: 'Mensagens',
        recent: 'Recente',
        recentChats: 'Chats recentes',
        loading: 'Carregando...',
        emoji: '[Emoji]',
        image: '[Imagem]',
        audio: '[Áudio]',

        // Estado vazio da página de chat
        selectChatToStart: 'Selecione um chat para começar',
        selectFromList: 'Selecione da lista ou crie uma nova conversa',
        selectChatForDetail: 'Selecione um chat para ver detalhes do personagem',

        // Mensagens toast
        toast: {
            noTopics: 'Nenhum tópico recomendado disponível',
            getTopicsFailed: 'Falha ao obter tópicos recomendados',
            noMessageToRefresh: 'Nenhuma mensagem para atualizar',
            editSuccess: 'Edição bem-sucedida',
            editFailed: 'Falha na edição',
            operationSuccess: 'Operação bem-sucedida',
            operationFailed: 'Operação falhou',
            selectImageFile: 'Por favor, selecione um arquivo de imagem',
            imageSizeLimit: 'O tamanho da imagem não pode exceder 100MB',
            uploading: 'Enviando...',
            uploadSuccess: 'Envio bem-sucedido',
            uploadFailed: 'Falha no envio',
            insufficientCoins: 'Moedas insuficientes, por favor recarregue',
            noImageToSave: 'Nenhuma imagem para salvar',
            noVideoToSave: 'Nenhum vídeo para salvar',
            saveSuccess: 'Salvo com sucesso',
            saveFailed: 'Falha ao salvar, por favor tente novamente',
            mediaLoadFailed: 'Falha ao carregar mídia',
            switchSuccess: 'Alterado para',
            switchFailed: 'Falha ao mudar modo',
            networkError: 'Erro de rede, por favor tente novamente',
            waitForAiReply: 'Por favor, aguarde a resposta da IA',
            sendFailed: 'Falha ao enviar, por favor tente novamente',
            regenerateFailed: 'Falha ao regenerar, por favor tente novamente',
            waitTimeout: 'Tempo de espera esgotado, por favor tente novamente',
            audioGenerateSuccess: 'Áudio gerado com sucesso',
            conversationNotExist: 'Conversa não existe',
            audioGenerateFailed: 'Falha ao gerar áudio',
            mediaGenerating: 'Gerando...',
            imageGenerating: 'Gerando imagem...',
            videoGenerating: 'Gerando vídeo...',
            mediaGenerateFailed: 'Falha na geração, tente novamente',
            mediaNetworkError: 'Erro de rede, tente novamente',
            heartUnlockSuccess: 'Desbloqueado com sucesso',
            heartUnlockFailed: 'Falha ao desbloquear',
        },
    },
    it: {
        // Scheda pagina chat
        tabChat: 'Chat',
        creation: 'Creazione',
        historyRecord: 'Cronologia',
        dialogueRecord: 'Cronologia dei Dialoghi',
        systemPromptEntry: 'Prompt',
        systemPromptTitle: 'Prompt di sistema',
        systemPromptSubtitle: 'Queste istruzioni verranno fornite con priorità all’IA in ogni conversazione.',
        systemPromptPlaceholder: 'Digita qui…',
        openSidebar: 'Apri barra laterale',
        noChat: 'Non hai ancora iniziato nessuna conversazione~',
        newChat: 'Nuova chat',
        rename: 'Rinomina',
        changeName: 'Cambia nome',
        renameChatTitle: 'Rinomina conversazione',
        renameChatPlaceholder: 'Inserisci un nuovo nome',
        renameSuccess: 'Rinominato con successo',
        renameFailed: 'Rinomina non riuscita',
        renameChatLimitTip: 'Limite di caratteri: {max}',
        noCreation: 'Nessuna creazione',
        newCreation: 'Nuova creazione',
        delete: 'Elimina',
        deleteSuccess: 'Eliminato con successo',
        deleteFailed: 'Eliminazione fallita',
        sendFailed: 'Invio fallito, riprova',
        needSendFirstMessage: 'Per favore invia prima il primo messaggio',
        loadingMore: 'Caricamento di altri messaggi...',

        // Modal di riduzione dialoghi
        reduceDialogueTitle: 'Riduci finestre di dialogo',
        reduceDialogueSubtitle: 'Rilevati record nelle finestre di dialogo. Ridurre il numero di finestre rimuoverà alcuni dialoghi e i loro record.',
        reduceDialogueSelect: 'Seleziona {count} finestra(e) da chiudere',
        windowName: 'Finestra {index}',
        noRecords: 'Nessun record',
        confirmDelete: 'Conferma eliminazione',

        // Modal chiusura dialogo
        closeDialogueTitle: 'Chiudi dialogo',
        closeDialogueSubtitle1: 'Chiudere questa finestra eliminerà tutti i record di conversazione in questa finestra.',
        closeDialogueSubtitle2: 'Questa azione non può essere annullata. Sei sicuro di voler continuare?',

        // Modal eliminazione chat
        deleteChatTitle: 'Eliminare la conversazione?',
        deleteChatConfirmMessage: 'Dopo l’eliminazione, i record della conversazione corrente non verranno conservati.',

        // Stato vuoto della chat
        emptyGreeting: 'Ciao,',
        emptySubtitle1: 'Come posso aiutarti',
        emptySubtitle2: 'oggi?',

        // Azioni messaggio
        copy: 'Copia',
        copyText: 'Copia testo',
        copySuccess: 'Copiato!',
        cancelEdit: 'Annulla',
        sendEdit: 'Invia',
        retry: 'Riprova',
        clickToResend: 'Clicca per reinviare',
        insufficientCreditsReply: 'Crediti insufficienti. Ricarica per continuare.',
        streamingTimeoutReply: 'Timeout della risposta, riprova',
        getMoreCredits: 'Ottieni più crediti',

        // Selezione modello
        switchModel: 'Cambia modello',
        model: 'Modello',
        credits: 'crediti',

        // Operazioni comuni
        edit: 'Modifica',
        cancel: 'Annulla',
        confirm: 'Conferma',
        processing: 'Elaborazione...',
        saving: 'Salvataggio...',
        save: 'Salva',
        enableDialogueModalTitle: 'Suggerimento',
        enableDialogueModalContent: 'Attiva la finestra di dialogo che vuoi usare.',
        enableDialogueTip: 'Attiva questo dialogo',
        disableDialogueTip: 'Disattiva questo dialogo',

        // Menu azioni messaggio
        startNewChatFromHere: 'Inizia nuova chat da qui',

        // Relativo al cuore
        viewHeart: 'Vedi cuore',
        heartMoment: 'Momento del cuore',
        unlocking: 'Sblocco in corso...',
        unlock: 'Sblocca',

        // Guida vocale
        voiceGuideText: 'Quando abilitato, le risposte del personaggio verranno riprodotte automaticamente con voce.',

        // Modal generazione media
        imageGeneration: 'Genera Immagine',
        videoGeneration: 'Genera Video',
        imageSubtitle: 'Genera visual esclusivi basati sulla conversazione attuale',
        videoSubtitle: 'Dai vita alle immagini statiche, cattura momenti in movimento',
        character: 'Personaggio',
        currentCharacter: 'Personaggio attuale',
        uploadYourPhoto: 'Carica la tua foto',
        optional: '(Opzionale)',
        imageHint: 'Puoi caricare una tua foto e genererò una foto di entrambi basata sul tuo aspetto. Se non caricata, genererò una foto singola basata sulla conversazione attuale.',
        videoHint: 'Puoi caricare una tua foto per generare un video duo con il personaggio. Se non caricata, verrà generato un video singolo del personaggio.',
        isPublic: 'Rendi pubblico',
        startGenerate: 'Avvia generazione',

        // Modal risultato media
        generatingImage: 'Generazione immagine...',
        generatingVideo: 'Generazione video...',
        imageGeneratingSubtitle: 'La generazione della foto richiede un momento. Una volta completata, la invierò direttamente nella nostra chat. Puoi continuare a chattare.',
        videoGeneratingSubtitle: 'La generazione del video richiede un momento. Una volta completata, lo invierò direttamente nella nostra chat. Puoi continuare a chattare.',
        continueChat: 'Continua Chat',
        imageComplete: 'Generazione Completata',
        videoComplete: 'Generazione Completata',
        imageCompleteSubtitle: 'Questo è il nostro ricordo esclusivo',
        videoCompleteSubtitle: 'Questo è il nostro ricordo esclusivo',
        saveImage: 'Salva foto',
        saveVideo: 'Salva video',
        generateFailed: 'Generazione fallita, riprova più tardi',
        gotIt: 'Capito',

        // Input chat
        inputPlaceholder: 'Cosa vorresti dire',

        // Modal modifica messaggio
        editMessage: 'Modifica messaggio',
        editDialogueTitle: 'Modifica messaggio',
        editPlaceholder: 'Inserisci il contenuto del messaggio',
        editHint: 'Suggerimento: Usa () per racchiudere azioni del personaggio, espressioni o descrizioni dell\'ambiente',

        // Modal conferma rollback
        rollbackTitle: 'Inizia nuova chat da qui',
        rollbackMessage: 'Iniziando la chat da qui verranno eliminati tutti i messaggi successivi. Sei sicuro?',

        // Selettore modalità
        switchChatMode: 'Cambia modalità chat',
        subscribe: 'Iscriviti',
        freeUnlimitedChat: 'Chat Illimitata Gratuita',
        vipMemberBanner: 'Diventa VIP e goditi',
        unlimitedChat: 'Chat illimitata',
        vipDescription: 'Doppia esperienza intensa e rilassante',
        vipDescriptionSuffix: 'VIP 0 monete chat illimitata, libera la tua immaginazione.',
        vipFree: 'VIP Gratis',
        vipOnly: 'Solo VIP',
        perMessage: '/msg',
        saveChanges: 'Salva modifiche',

        // Lista messaggi
        messageList: 'Messaggi',
        recent: 'Recenti',
        recentChats: 'Chat recenti',
        loading: 'Caricamento...',
        emoji: '[Emoji]',
        image: '[Immagine]',
        audio: '[Audio]',

        // Stato vuoto pagina chat
        selectChatToStart: 'Seleziona una chat per iniziare',
        selectFromList: 'Seleziona dalla lista o crea una nuova conversazione',
        selectChatForDetail: 'Seleziona una chat per vedere i dettagli del personaggio',

        // Messaggi toast
        toast: {
            noTopics: 'Nessun argomento consigliato disponibile',
            getTopicsFailed: 'Impossibile ottenere argomenti consigliati',
            noMessageToRefresh: 'Nessun messaggio da aggiornare',
            editSuccess: 'Modifica riuscita',
            editFailed: 'Modifica fallita',
            operationSuccess: 'Operazione riuscita',
            operationFailed: 'Operazione fallita',
            selectImageFile: 'Seleziona un file immagine',
            imageSizeLimit: 'La dimensione dell\'immagine non può superare 100MB',
            uploading: 'Caricamento...',
            uploadSuccess: 'Caricamento riuscito',
            uploadFailed: 'Caricamento fallito',
            insufficientCoins: 'Monete insufficienti, ricarica',
            noImageToSave: 'Nessuna immagine da salvare',
            noVideoToSave: 'Nessun video da salvare',
            saveSuccess: 'Salvato con successo',
            saveFailed: 'Salvataggio fallito, riprova',
            mediaLoadFailed: 'Caricamento media fallito',
            switchSuccess: 'Cambiato a',
            switchFailed: 'Cambio modalità fallito',
            networkError: 'Errore di rete, riprova',
            waitForAiReply: 'Attendere la risposta dell\'IA',
            sendFailed: 'Invio fallito, riprova',
            regenerateFailed: 'Rigenerazione fallita, riprova',
            waitTimeout: 'Tempo di attesa scaduto, riprova',
            audioGenerateSuccess: 'Audio generato con successo',
            conversationNotExist: 'La conversazione non esiste',
            audioGenerateFailed: 'Generazione audio fallita',
            mediaGenerating: 'Generazione in corso...',
            imageGenerating: 'Generazione immagine...',
            videoGenerating: 'Generazione video...',
            mediaGenerateFailed: 'Generazione fallita, riprova',
            mediaNetworkError: 'Errore di rete, riprova',
            heartUnlockSuccess: 'Sbloccato con successo',
            heartUnlockFailed: 'Sblocco fallito',
        },
    },
    ar: {
        // علامة تبويب صفحة الدردشة
        tabChat: 'الدردشة',
        creation: 'إنشاء',
        historyRecord: 'السجل',
        dialogueRecord: 'سجل الحوارات',
        systemPromptEntry: 'برومبت',
        systemPromptTitle: 'برومبت النظام',
        systemPromptSubtitle: 'سيتم تزويد الذكاء الاصطناعي بهذه التعليمات أولاً في كل محادثة.',
        systemPromptPlaceholder: 'اكتب هنا…',
        openSidebar: 'فتح الشريط الجانبي',
        noChat: 'لم تبدأ أي محادثة بعد~',
        newChat: 'محادثة جديدة',
        rename: 'إعادة التسمية',
        changeName: 'تغيير الاسم',
        renameChatTitle: 'إعادة تسمية المحادثة',
        renameChatPlaceholder: 'الرجاء إدخال اسم جديد',
        renameSuccess: 'تمّت إعادة التسمية بنجاح',
        renameFailed: 'فشل في إعادة التسمية',
        renameChatLimitTip: 'الحد الأقصى لعدد الأحرف هو {max}',
        noCreation: 'لا توجد إبداعات',
        newCreation: 'إنشاء جديد',
        delete: 'حذف',
        deleteSuccess: 'تم الحذف بنجاح',
        deleteFailed: 'فشل الحذف',
        sendFailed: 'فشل الإرسال، يرجى المحاولة مرة أخرى',
        needSendFirstMessage: 'يرجى إرسال الرسالة الأولى أولاً',
        loadingMore: 'جاري تحميل المزيد من الرسائل...',

        // حالة الدردشة الفارغة
        emptyGreeting: 'مرحباً،',
        emptySubtitle1: 'كيف يمكنني مساعدتك',
        emptySubtitle2: 'اليوم؟',

        // نافذة تقليل الحوارات
        reduceDialogueTitle: 'تقليل نوافذ الحوار',
        reduceDialogueSubtitle: 'تم اكتشاف سجلات في نوافذ الحوار. تقليل عدد النوافذ سيؤدي إلى إزالة بعض الحوارات وسجلاتها.',
        reduceDialogueSelect: 'يرجى اختيار {count} نافذة(نوافذ) للإغلاق',
        windowName: 'نافذة {index}',
        noRecords: 'لا توجد سجلات',
        confirmDelete: 'تأكيد الحذف',

        // نافذة إغلاق الحوار
        closeDialogueTitle: 'إغلاق الحوار',
        closeDialogueSubtitle1: 'إغلاق هذه النافذة سيحذف جميع سجلات المحادثة في هذه النافذة.',
        closeDialogueSubtitle2: 'لا يمكن التراجع عن هذا الإجراء. هل أنت متأكد من أنك تريد المتابعة؟',

        // نافذة حذف المحادثة
        deleteChatTitle: 'حذف المحادثة؟',
        deleteChatConfirmMessage: 'بعد الحذف، لن يتم الاحتفاظ بسجلات المحادثة الحالية.',

        // إجراءات الرسائل
        copy: 'نسخ',
        copyText: 'نسخ النص',
        copySuccess: 'تم النسخ!',
        cancelEdit: 'إلغاء',
        sendEdit: 'إرسال',
        retry: 'إعادة المحاولة',
        clickToResend: 'انقر لإعادة الإرسال',
        insufficientCreditsReply: 'رصيد غير كافٍ. يرجى إعادة الشحن للمتابعة.',
        streamingTimeoutReply: 'انتهت مهلة الاستجابة، يرجى المحاولة مرة أخرى',
        getMoreCredits: 'الحصول على المزيد من الرصيد',

        // اختيار النموذج
        switchModel: 'تغيير النموذج',
        model: 'النموذج',
        credits: 'رصيد',

        // العمليات الشائعة
        edit: 'تعديل',
        cancel: 'إلغاء',
        confirm: 'تأكيد',
        processing: 'جاري المعالجة...',
        saving: 'جاري الحفظ...',
        save: 'حفظ',
        enableDialogueModalTitle: 'نصيحة',
        enableDialogueModalContent: 'يرجى تفعيل نافذة الحوار التي تريد استخدامها.',
        enableDialogueTip: 'تفعيل هذا الحوار',
        disableDialogueTip: 'تعطيل هذا الحوار',

        // قائمة إجراءات الرسالة
        startNewChatFromHere: 'بدء محادثة جديدة من هنا',

        // متعلق بالقلب
        viewHeart: 'عرض القلب',
        heartMoment: 'لحظة القلب',
        unlocking: 'جاري فتح القفل...',
        unlock: 'فتح القفل',

        // دليل الصوت
        voiceGuideText: 'عند التفعيل، سيتم تشغيل ردود الشخصية تلقائياً بالصوت.',

        // نافذة إنشاء الوسائط
        imageGeneration: 'إنشاء صورة',
        videoGeneration: 'إنشاء فيديو',
        imageSubtitle: 'أنشئ صورًا حصرية بناءً على المحادثة الحالية',
        videoSubtitle: 'إحياء الصور الثابتة، التقاط لحظات متحركة',
        character: 'شخصية',
        currentCharacter: 'الشخصية الحالية',
        uploadYourPhoto: 'ارفع صورتك',
        optional: '(اختياري)',
        imageHint: 'يمكنك رفع صورة لك، وسأنشئ صورة لكلانا بناءً على مظهرك. إذا لم يتم الرفع، سأنشئ صورة فردية بناءً على المحادثة الحالية.',
        videoHint: 'يمكنك رفع صورة لك لإنشاء فيديو ثنائي مع الشخصية. إذا لم يتم الرفع، سيتم إنشاء فيديو فردي للشخصية.',
        isPublic: 'جعله عاماً',
        startGenerate: 'بدء الإنشاء',

        // نافذة نتيجة الوسائط
        generatingImage: 'جاري إنشاء الصورة...',
        generatingVideo: 'جاري إنشاء الفيديو...',
        imageGeneratingSubtitle: 'يستغرق إنشاء الصورة بعض الوقت. بمجرد الانتهاء، سأرسل الصورة مباشرة إلى محادثتنا. يمكنك متابعة الدردشة.',
        videoGeneratingSubtitle: 'يستغرق إنشاء الفيديو بعض الوقت. بمجرد الانتهاء، سأرسل الفيديو مباشرة إلى محادثتنا. يمكنك متابعة الدردشة.',
        continueChat: 'متابعة الدردشة',
        imageComplete: 'اكتمل الإنشاء',
        videoComplete: 'اكتمل الإنشاء',
        imageCompleteSubtitle: 'هذه ذكرى حصرية لنا',
        videoCompleteSubtitle: 'هذه ذكرى حصرية لنا',
        saveImage: 'حفظ الصورة',
        saveVideo: 'حفظ الفيديو',
        generateFailed: 'فشل الإنشاء، يرجى المحاولة مرة أخرى لاحقاً',
        gotIt: 'فهمت',

        // إدخال المحادثة
        inputPlaceholder: 'ماذا تريد أن تقول',

        // نافذة تعديل الرسالة
        editMessage: 'تعديل الرسالة',
        editDialogueTitle: 'تعديل الرسالة',
        editPlaceholder: 'يرجى إدخال محتوى الرسالة',
        editHint: 'نصيحة: استخدم () لتغليف أفعال الشخصية أو تعبيراتها أو أوصاف البيئة',

        // نافذة تأكيد التراجع
        rollbackTitle: 'بدء محادثة جديدة من هنا',
        rollbackMessage: 'سيؤدي بدء المحادثة من هنا إلى حذف جميع الرسائل اللاحقة. هل أنت متأكد؟',

        // محدد الوضع
        switchChatMode: 'تغيير وضع المحادثة',
        subscribe: 'اشترك',
        freeUnlimitedChat: 'دردشة غير محدودة مجانية',
        vipMemberBanner: 'كن VIP واستمتع',
        unlimitedChat: 'بمحادثة غير محدودة',
        vipDescription: 'تجربة مزدوجة مكثفة ومريحة',
        vipDescriptionSuffix: 'VIP 0 عملة محادثة غير محدودة، أطلق العنان لخيالك.',
        vipFree: 'VIP مجاني',
        vipOnly: 'VIP فقط',
        perMessage: '/رسالة',
        saveChanges: 'حفظ التغييرات',

        // قائمة الرسائل
        messageList: 'الرسائل',
        recent: 'الأخيرة',
        recentChats: 'المحادثات الأخيرة',
        loading: 'جاري التحميل...',
        emoji: '[إيموجي]',
        image: '[صورة]',
        audio: '[صوت]',

        // حالة صفحة المحادثة الفارغة
        selectChatToStart: 'اختر محادثة للبدء',
        selectFromList: 'اختر من القائمة أو أنشئ محادثة جديدة',
        selectChatForDetail: 'اختر محادثة لعرض تفاصيل الشخصية',

        // رسائل التنبيه
        toast: {
            noTopics: 'لا توجد مواضيع مقترحة متاحة',
            getTopicsFailed: 'فشل في الحصول على المواضيع المقترحة',
            noMessageToRefresh: 'لا توجد رسالة للتحديث',
            editSuccess: 'تم التعديل بنجاح',
            editFailed: 'فشل التعديل',
            operationSuccess: 'تمت العملية بنجاح',
            operationFailed: 'فشلت العملية',
            selectImageFile: 'يرجى اختيار ملف صورة',
            imageSizeLimit: 'لا يمكن أن يتجاوز حجم الصورة 100 ميجابايت',
            uploading: 'جاري الرفع...',
            uploadSuccess: 'تم الرفع بنجاح',
            uploadFailed: 'فشل الرفع',
            insufficientCoins: 'العملات غير كافية، يرجى الشحن',
            noImageToSave: 'لا توجد صورة للحفظ',
            noVideoToSave: 'لا يوجد فيديو للحفظ',
            saveSuccess: 'تم الحفظ بنجاح',
            saveFailed: 'فشل الحفظ، يرجى المحاولة مرة أخرى',
            mediaLoadFailed: 'فشل تحميل الوسائط',
            switchSuccess: 'تم التغيير إلى',
            switchFailed: 'فشل تغيير الوضع',
            networkError: 'خطأ في الشبكة، يرجى المحاولة مرة أخرى',
            waitForAiReply: 'يرجى انتظار رد الذكاء الاصطناعي',
            sendFailed: 'فشل الإرسال، يرجى المحاولة مرة أخرى',
            regenerateFailed: 'فشل إعادة التوليد، يرجى المحاولة مرة أخرى',
            waitTimeout: 'انتهت مهلة الانتظار، يرجى المحاولة مرة أخرى',
            audioGenerateSuccess: 'تم إنشاء الصوت بنجاح',
            conversationNotExist: 'المحادثة غير موجودة',
            audioGenerateFailed: 'فشل إنشاء الصوت',
            mediaGenerating: 'جاري الإنشاء...',
            imageGenerating: 'جاري إنشاء الصورة...',
            videoGenerating: 'جاري إنشاء الفيديو...',
            mediaGenerateFailed: 'فشل الإنشاء، حاول مرة أخرى',
            mediaNetworkError: 'خطأ في الشبكة، حاول مرة أخرى',
            heartUnlockSuccess: 'تم إلغاء القفل بنجاح',
            heartUnlockFailed: 'فشل إلغاء القفل',
        },
    },
    th: {
        // แท็บหน้าแชท
        tabChat: 'แชท',
        creation: 'การสร้าง',
        historyRecord: 'ประวัติ',
        dialogueRecord: 'ประวัติการสนทนา',
        systemPromptEntry: 'พรอมป์',
        systemPromptTitle: 'พรอมป์ของระบบ',
        systemPromptSubtitle: 'คำสั่งเหล่านี้จะถูกส่งให้ AI ก่อนทุกครั้งที่เริ่มบทสนทนา',
        systemPromptPlaceholder: 'พิมพ์ที่นี่…',
        openSidebar: 'เปิดแถบด้านข้าง',
        noChat: 'คุณยังไม่ได้เริ่มบทสนทนาเลยนะ~',
        newChat: 'แชทใหม่',
        rename: 'เปลี่ยนชื่อ',
        changeName: 'เปลี่ยนชื่อ',
        renameChatTitle: 'เปลี่ยนชื่อบทสนทนา',
        renameChatPlaceholder: 'โปรดป้อนชื่อใหม่',
        renameSuccess: 'เปลี่ยนชื่อสำเร็จ',
        renameFailed: 'เปลี่ยนชื่อล้มเหลว',
        renameChatLimitTip: 'จำกัดอักขระ {max} ตัว',
        noCreation: 'ยังไม่มีผลงาน',
        newCreation: 'สร้างใหม่',
        delete: 'ลบ',
        deleteSuccess: 'ลบสำเร็จ',
        deleteFailed: 'ลบไม่สำเร็จ',
        sendFailed: 'ส่งไม่สำเร็จ กรุณาลองใหม่',
        needSendFirstMessage: 'กรุณาส่งข้อความแรกก่อน',
        loadingMore: 'กำลังโหลดข้อความเพิ่มเติม...',

        // สถานะแชทว่างเปล่า
        emptyGreeting: 'สวัสดี,',
        emptySubtitle1: 'วันนี้ฉันช่วยอะไร',
        emptySubtitle2: 'คุณได้บ้าง?',

        // โมดัลลดหน้าต่างบทสนทนา
        reduceDialogueTitle: 'ลดหน้าต่างบทสนทนา',
        reduceDialogueSubtitle: 'ตรวจพบบันทึกในหน้าต่างบทสนทนา การลดจำนวนหน้าต่างจะลบบทสนทนาและบันทึกบางส่วน',
        reduceDialogueSelect: 'กรุณาเลือก {count} หน้าต่างที่จะปิด',
        windowName: 'หน้าต่าง {index}',
        noRecords: 'ไม่มีบันทึก',
        confirmDelete: 'ยืนยันการลบ',

        // โมดัลปิดบทสนทนา
        closeDialogueTitle: 'ปิดบทสนทนา',
        closeDialogueSubtitle1: 'การปิดหน้าต่างนี้จะลบบันทึกการสนทนาทั้งหมดในหน้าต่างนี้',
        closeDialogueSubtitle2: 'การดำเนินการนี้ไม่สามารถยกเลิกได้ คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?',

        // โมดัลลบแชท
        deleteChatTitle: 'ลบบทสนทนา?',
        deleteChatConfirmMessage: 'หลังจากลบแล้ว บันทึกการสนทนาปัจจุบันจะไม่ถูกเก็บไว้',

        // การดำเนินการข้อความ
        copy: 'คัดลอก',
        copyText: 'คัดลอกข้อความ',
        copySuccess: 'คัดลอกแล้ว!',
        cancelEdit: 'ยกเลิก',
        sendEdit: 'ส่ง',
        retry: 'ลองอีกครั้ง',
        clickToResend: 'คลิกเพื่อส่งใหม่',
        insufficientCreditsReply: 'เครดิตไม่เพียงพอ กรุณาเติมเงินเพื่อดำเนินการต่อ',
        streamingTimeoutReply: 'การตอบกลับหมดเวลา กรุณาลองอีกครั้ง',
        getMoreCredits: 'รับเครดิตเพิ่มเติม',

        // การเลือกโมเดล
        switchModel: 'เปลี่ยนโมเดล',
        model: 'โมเดล',
        credits: 'เครดิต',

        // Common operations
        edit: 'แก้ไข',
        cancel: 'ยกเลิก',
        confirm: 'ยืนยัน',
        processing: 'กำลังประมวลผล...',
        saving: 'กำลังบันทึก...',
        save: 'บันทึก',
        enableDialogueModalTitle: 'คำแนะนำ',
        enableDialogueModalContent: 'โปรดเปิดใช้งานหน้าต่างบทสนทนาที่คุณต้องการใช้',
        enableDialogueTip: 'เปิดใช้งานบทสนทนานี้',
        disableDialogueTip: 'ปิดใช้งานบทสนทนานี้',

        // Message action menu
        startNewChatFromHere: 'เริ่มแชทใหม่จากตรงนี้',

        // Heart related
        viewHeart: 'ดูหัวใจ',
        heartMoment: 'ช่วงเวลาหัวใจ',
        unlocking: 'กำลังปลดล็อก...',
        unlock: 'ปลดล็อก',

        // Voice guide
        voiceGuideText: 'เมื่อเปิดใช้งาน การตอบกลับของตัวละครจะสร้างเสียงอัตโนมัติ',

        // Media generation modal
        imageGeneration: 'สร้างรูปภาพ',
        videoGeneration: 'สร้างวิดีโอ',
        imageSubtitle: 'สร้างภาพพิเศษจากบทสนทนาปัจจุบัน',
        videoSubtitle: 'ทำให้ภาพนิ่งมีชีวิต จับช่วงเวลาที่ไหลลื่น',
        character: 'ตัวละคร',
        currentCharacter: 'ตัวละครปัจจุบัน',
        uploadYourPhoto: 'อัปโหลดรูปของคุณ',
        optional: '(ไม่บังคับ)',
        imageHint: 'คุณสามารถอัปโหลดรูปของตัวเอง แล้วฉันจะสร้างรูปของเราทั้งคู่ตามรูปลักษณ์ของคุณ หากไม่อัปโหลด ฉันจะสร้างรูปเดี่ยวจากบทสนทนาปัจจุบัน',
        videoHint: 'คุณสามารถอัปโหลดรูปของตัวเองเพื่อสร้างวิดีโอคู่กับตัวละคร หากไม่อัปโหลด จะสร้างวิดีโอเดี่ยวของตัวละคร',
        startGenerate: 'เริ่มสร้าง',

        // Media result modal
        generatingImage: 'กำลังสร้างรูปภาพ...',
        generatingVideo: 'กำลังสร้างวิดีโอ...',
        imageGeneratingSubtitle: 'การสร้างรูปภาพใช้เวลาสักครู่ เมื่อเสร็จแล้วฉันจะส่งรูปไปยังแชท สามารถคุยต่อได้เลย',
        videoGeneratingSubtitle: 'การสร้างวิดีโอใช้เวลาสักครู่ เมื่อเสร็จแล้วฉันจะส่งวิดีโอไปยังแชท สามารถคุยต่อได้เลย',
        continueChat: 'คุยต่อ',
        imageComplete: 'สร้างเสร็จแล้ว',
        videoComplete: 'สร้างเสร็จแล้ว',
        imageCompleteSubtitle: 'นี่คือความทรงจำพิเศษของเรา',
        videoCompleteSubtitle: 'นี่คือความทรงจำพิเศษของเรา',
        saveImage: 'บันทึกรูปภาพ',
        saveVideo: 'บันทึกวิดีโอ',
        generateFailed: 'สร้างไม่สำเร็จ โปรดลองอีกครั้งภายหลัง',
        gotIt: 'เข้าใจแล้ว',

        // Chat input
        inputPlaceholder: 'คุณอยากพูดว่าอะไร',

        // Edit message modal
        editMessage: 'แก้ไขข้อความ',
        editDialogueTitle: 'แก้ไขข้อความ',
        editPlaceholder: 'กรุณากรอกเนื้อหาข้อความ',
        editHint: 'เคล็ดลับ: ใช้ () ครอบการกระทำ สีหน้า หรือคำบรรยายสภาพแวดล้อม',

        // Rollback confirmation modal
        rollbackTitle: 'เริ่มแชทใหม่จากตรงนี้',
        rollbackMessage: 'การเริ่มแชทจากตรงนี้จะลบข้อความถัดไปทั้งหมด แน่ใจหรือไม่?',

        // Mode selector
        switchChatMode: 'สลับโหมดแชท',
        subscribe: 'สมัครสมาชิก',
        freeUnlimitedChat: 'แชทไม่จำกัดฟรี',
        vipMemberBanner: 'เป็น VIP แล้วรับสิทธิ์',
        unlimitedChat: 'แชทไม่จำกัด',
        vipDescription: 'ประสบการณ์สองโหมด เข้มข้น & ชิล',
        vipDescriptionSuffix: 'VIP 0 เหรียญแชทไม่จำกัด ปลดปล่อยจินตนาการของคุณ',
        vipFree: 'VIP ฟรี',
        vipOnly: 'เฉพาะ VIP',
        perMessage: '/ข้อความ',
        saveChanges: 'บันทึกการเปลี่ยนแปลง',

        // Message list
        messageList: 'ข้อความ',
        recent: 'ล่าสุด',
        recentChats: 'แชทล่าสุด',
        loading: 'กำลังโหลด...',
        emoji: '[อีโมจิ]',
        image: '[รูปภาพ]',
        audio: '[เสียง]',

        // Chat page empty state
        selectChatToStart: 'เลือกแชทเพื่อเริ่ม',
        selectFromList: 'เลือกจากรายการหรือสร้างบทสนทนาใหม่',
        selectChatForDetail: 'เลือกแชทเพื่อดูรายละเอียดตัวละคร',

        // Toast messages
        toast: {
            noTopics: 'ไม่มีหัวข้อแนะนำ',
            getTopicsFailed: 'ดึงหัวข้อแนะนำล้มเหลว',
            noMessageToRefresh: 'ไม่มีข้อความให้รีเฟรช',
            editSuccess: 'แก้ไขสำเร็จ',
            editFailed: 'แก้ไขล้มเหลว',
            operationSuccess: 'ดำเนินการสำเร็จ',
            operationFailed: 'ดำเนินการล้มเหลว',
            selectImageFile: 'โปรดเลือกไฟล์รูปภาพ',
            imageSizeLimit: 'ขนาดรูปภาพต้องไม่เกิน 100MB',
            uploading: 'กำลังอัปโหลด...',
            uploadSuccess: 'อัปโหลดสำเร็จ',
            uploadFailed: 'อัปโหลดล้มเหลว',
            insufficientCoins: 'เหรียญไม่พอ โปรดเติมเงิน',
            noImageToSave: 'ไม่มีรูปภาพให้บันทึก',
            noVideoToSave: 'ไม่มีวิดีโอให้บันทึก',
            saveSuccess: 'บันทึกสำเร็จ',
            saveFailed: 'บันทึกล้มเหลว โปรดลองอีกครั้ง',
            mediaLoadFailed: 'โหลดสื่อไม่สำเร็จ',
            switchSuccess: 'สลับเป็น',
            switchFailed: 'สลับโหมดไม่สำเร็จ',
            networkError: 'เกิดข้อผิดพลาดเครือข่าย โปรดลองอีกครั้ง',
            waitForAiReply: 'โปรดรอการตอบจาก AI',
            sendFailed: 'ส่งไม่สำเร็จ โปรดลองอีกครั้ง',
            regenerateFailed: 'สร้างใหม่ไม่สำเร็จ โปรดลองอีกครั้ง',
            waitTimeout: 'หมดเวลารอ โปรดลองอีกครั้ง',
            audioGenerateSuccess: 'สร้างเสียงสำเร็จ',
            conversationNotExist: 'ไม่พบการสนทนา',
            audioGenerateFailed: 'สร้างเสียงไม่สำเร็จ',
            mediaGenerating: 'กำลังสร้าง...',
            imageGenerating: 'กำลังสร้างรูปภาพ...',
            videoGenerating: 'กำลังสร้างวิดีโอ...',
            mediaGenerateFailed: 'สร้างไม่สำเร็จ โปรดลองอีกครั้ง',
            mediaNetworkError: 'เครือข่ายผิดพลาด โปรดลองอีกครั้ง',
            heartUnlockSuccess: 'ปลดล็อกสำเร็จ',
            heartUnlockFailed: 'ปลดล็อกไม่สำเร็จ',
            },
    },
    da: {
        // Chat-side fane
        tabChat: 'Chat',
        creation: 'Kreation',
        historyRecord: 'Historik',
        dialogueRecord: 'Dialoghistorik',
        systemPromptEntry: 'Prompt',
        systemPromptTitle: 'Systemprompt',
        systemPromptSubtitle: 'Disse instruktioner gives prioritet og sendes først til AI i hver samtale.',
        systemPromptPlaceholder: 'Skriv her…',
        openSidebar: 'Åbn sidebjælke',
        noChat: 'Du har endnu ikke startet nogen samtale~',
        newChat: 'Ny chat',
        rename: 'Omdøb',
        changeName: 'Skift navn',
        renameChatTitle: 'Omdøb samtale',
        renameChatPlaceholder: 'Indtast et nyt navn',
        renameSuccess: 'Omdøbt',
        renameFailed: 'Omdøbning mislykkedes',
        renameChatLimitTip: 'Tegngrænse: {max}',
        noCreation: 'Ingen kreationer',
        newCreation: 'Ny kreation',
        delete: 'Slet',
        deleteSuccess: 'Slettet',
        deleteFailed: 'Sletning mislykkedes',
        sendFailed: 'Afsendelse mislykkedes, prøv igen',
        needSendFirstMessage: 'Send venligst den første besked først',
        loadingMore: 'Indlæser flere beskeder...',

        // Tom chat-tilstand
        emptyGreeting: 'Hej,',
        emptySubtitle1: 'Hvordan kan jeg hjælpe dig',
        emptySubtitle2: 'i dag?',

        // Modal til reduktion af dialogvinduer
        reduceDialogueTitle: 'Reducer dialogvinduer',
        reduceDialogueSubtitle: 'Der blev fundet poster i dialogvinduerne. Reduktion af antallet af vinduer vil fjerne nogle dialoger og deres poster.',
        reduceDialogueSelect: 'Vælg venligst {count} vindue(r) at lukke',
        windowName: 'Vindue {index}',
        noRecords: 'Ingen poster',
        confirmDelete: 'Bekræft sletning',

        // Modal til lukning af dialog
        closeDialogueTitle: 'Luk dialog',
        closeDialogueSubtitle1: 'Lukning af dette vindue vil slette alle samtalehistorikker i dette vindue.',
        closeDialogueSubtitle2: 'Denne handling kan ikke fortrydes. Er du sikker på, at du vil fortsætte?',

        // Slet chat modal
        deleteChatTitle: 'Slet samtale?',
        deleteChatConfirmMessage: 'Efter sletning vil de aktuelle samtaleregistreringer ikke blive gemt.',

        // Beskedhandlinger
        copy: 'Kopier',
        copyText: 'Kopier tekst',
        copySuccess: 'Kopieret!',
        cancelEdit: 'Annuller',
        sendEdit: 'Send',
        retry: 'Prøv igen',
        clickToResend: 'Klik for at sende igen',
        insufficientCreditsReply: 'Utilstrækkelig kredit. Genoplad venligst for at fortsætte.',
        streamingTimeoutReply: 'Svartid udløbet, prøv venligst igen',
        getMoreCredits: 'Få flere kreditter',

        // Modelvalg
        switchModel: 'Skift model',
        model: 'Model',
        credits: 'kreditter',

        // Common operations
        edit: 'Rediger',
        cancel: 'Annuller',
        confirm: 'Bekræft',
        processing: 'Behandler...',
        saving: 'Gemmer...',
        save: 'Gem',
        enableDialogueModalTitle: 'Tip',
        enableDialogueModalContent: 'Aktivér det dialogvindue, du vil bruge.',
        enableDialogueTip: 'Aktivér denne dialog',
        disableDialogueTip: 'Deaktivér denne dialog',

        // Message action menu
        startNewChatFromHere: 'Start ny chat herfra',

        // Heart related
        viewHeart: 'Se hjerte',
        heartMoment: 'Hjerteøjeblik',
        unlocking: 'Låser op...',
        unlock: 'Lås op',

        // Voice guide
        voiceGuideText: 'Når den er aktiveret, afspilles karakterens svar automatisk som tale.',

        // Media generation modal
        imageGeneration: 'Generér billede',
        videoGeneration: 'Generér video',
        imageSubtitle: 'Generér eksklusive billeder baseret på den aktuelle samtale',
        videoSubtitle: 'Giv stillbilleder liv, fang flydende øjeblikke',
        character: 'Karakter',
        currentCharacter: 'Nuværende karakter',
        uploadYourPhoto: 'Upload dit foto',
        optional: '(Valgfrit)',
        imageHint: 'Du kan uploade et foto af dig selv, og jeg genererer et foto af os begge baseret på dit udseende. Hvis du ikke uploader, genererer jeg et solofoto baseret på den aktuelle samtale.',
        videoHint: 'Du kan uploade et foto af dig selv for at generere en duo-video med karakteren. Hvis du ikke uploader, genereres en solo-video af karakteren.',
        startGenerate: 'Start generering',

        // Media result modal
        generatingImage: 'Genererer billede...',
        generatingVideo: 'Genererer video...',
        imageGeneratingSubtitle: 'Fotogenerering tager et øjeblik. Når det er færdigt, sender jeg billedet direkte til chatten. Du kan fortsætte med at chatte.',
        videoGeneratingSubtitle: 'Videogenerering tager et øjeblik. Når det er færdigt, sender jeg videoen direkte til chatten. Du kan fortsætte med at chatte.',
        continueChat: 'Fortsæt chat',
        imageComplete: 'Generering fuldført',
        videoComplete: 'Generering fuldført',
        imageCompleteSubtitle: 'Dette er vores eksklusive minde',
        videoCompleteSubtitle: 'Dette er vores eksklusive minde',
        saveImage: 'Gem foto',
        saveVideo: 'Gem video',
        generateFailed: 'Generering mislykkedes, prøv igen senere',
        gotIt: 'Forstået',

        // Chat input
        inputPlaceholder: 'Hvad vil du gerne sige',

        // Edit message modal
        editMessage: 'Rediger besked',
        editDialogueTitle: 'Rediger besked',
        editPlaceholder: 'Indtast beskedindhold',
        editHint: 'Tip: Brug () til at omslutte karakterhandlinger, udtryk eller miljøbeskrivelser',

        // Rollback confirmation modal
        rollbackTitle: 'Start ny chat herfra',
        rollbackMessage: 'At starte chatten herfra vil slette alle efterfølgende beskeder. Er du sikker?',

        // Mode selector
        switchChatMode: 'Skift chattilstand',
        subscribe: 'Abonnér',
        freeUnlimitedChat: 'Gratis ubegrænset chat',
        vipMemberBanner: 'Bliv VIP og nyd',
        unlimitedChat: 'Ubegrænset chat',
        vipDescription: 'Intens & chill dobbeltoplevelse',
        vipDescriptionSuffix: 'VIP 0 mønter ubegrænset chat, slip fantasien løs.',
        vipFree: 'VIP gratis',
        vipOnly: 'Kun VIP',
        perMessage: '/besked',
        saveChanges: 'Gem ændringer',

        // Message list
        messageList: 'Beskeder',
        recent: 'Seneste',
        recentChats: 'Seneste chats',
        loading: 'Indlæser...',
        emoji: '[Emoji]',
        image: '[Billede]',
        audio: '[Lyd]',

        // Chat page empty state
        selectChatToStart: 'Vælg en chat for at starte',
        selectFromList: 'Vælg fra listen eller opret en ny samtale',
        selectChatForDetail: 'Vælg en chat for at se karakterdetaljer',

        // Toast messages
        toast: {
            noTopics: 'Ingen anbefalede emner tilgængelige',
            getTopicsFailed: 'Kunne ikke hente anbefalede emner',
            noMessageToRefresh: 'Ingen besked at opdatere',
            editSuccess: 'Redigering lykkedes',
            editFailed: 'Redigering mislykkedes',
            operationSuccess: 'Handlingen lykkedes',
            operationFailed: 'Handlingen mislykkedes',
            selectImageFile: 'Vælg venligst en billedfil',
            imageSizeLimit: 'Billedstørrelsen må ikke overstige 100MB',
            uploading: 'Uploader...',
            uploadSuccess: 'Upload lykkedes',
            uploadFailed: 'Upload mislykkedes',
            insufficientCoins: 'Utilstrækkelige mønter, genoplad venligst',
            noImageToSave: 'Intet billede at gemme',
            noVideoToSave: 'Ingen video at gemme',
            saveSuccess: 'Gemt',
            saveFailed: 'Gem mislykkedes, prøv igen',
            mediaLoadFailed: 'Medie kunne ikke indlæses',
            switchSuccess: 'Skiftet til',
            switchFailed: 'Skift af tilstand mislykkedes',
            networkError: 'Netværksfejl, prøv igen',
            waitForAiReply: 'Vent på AI-svar',
            sendFailed: 'Afsendelse mislykkedes, prøv igen',
            regenerateFailed: 'Kunne ikke regenerere, prøv igen',
            waitTimeout: 'Ventetid udløb, prøv igen',
            audioGenerateSuccess: 'Lyd genereret',
            conversationNotExist: 'Samtalen findes ikke',
            audioGenerateFailed: 'Kunne ikke generere lyd',
            mediaGenerating: 'Genererer...',
            imageGenerating: 'Genererer billede...',
            videoGenerating: 'Genererer video...',
            mediaGenerateFailed: 'Generering mislykkedes, prøv igen',
            mediaNetworkError: 'Netværksfejl, prøv igen',
            heartUnlockSuccess: 'Låst op',
            heartUnlockFailed: 'Kunne ikke låse op',
            },
    },
    no: {
        // Chat-sidefane
        tabChat: 'Chat',
        creation: 'Kreasjon',
        historyRecord: 'Historikk',
        dialogueRecord: 'Dialoghistorikk',
        systemPromptEntry: 'Prompt',
        systemPromptTitle: 'Systemprompt',
        systemPromptSubtitle: 'Disse instruksjonene vil bli prioritert og gitt til AI i hver samtale.',
        systemPromptPlaceholder: 'Skriv her…',
        openSidebar: 'Åpne sidepanel',
        noChat: 'Du har ikke startet noen samtale ennå~',
        newChat: 'Ny chat',
        rename: 'Gi nytt navn',
        changeName: 'Endre navn',
        renameChatTitle: 'Gi nytt navn til samtale',
        renameChatPlaceholder: 'Skriv inn et nytt navn',
        renameSuccess: 'Navn endret',
        renameFailed: 'Kunne ikke endre navn',
        renameChatLimitTip: 'Tegngrense: {max}',
        noCreation: 'Ingen kreasjoner',
        newCreation: 'Ny kreasjon',
        delete: 'Slett',
        deleteSuccess: 'Slettet',
        deleteFailed: 'Sletting mislyktes',
        sendFailed: 'Sending mislyktes, prøv igjen',
        needSendFirstMessage: 'Vennligst send den første meldingen først',
        loadingMore: 'Laster flere meldinger...',

        // Tom chat-tilstand
        emptyGreeting: 'Hei,',
        emptySubtitle1: 'Hvordan kan jeg hjelpe deg',
        emptySubtitle2: 'i dag?',

        // Modal for reduksjon av dialogvinduer
        reduceDialogueTitle: 'Reduser dialogvinduer',
        reduceDialogueSubtitle: 'Poster ble funnet i dialogvinduene. Å redusere antall vinduer vil fjerne noen dialoger og deres poster.',
        reduceDialogueSelect: 'Velg {count} vindu(er) å lukke',
        windowName: 'Vindu {index}',
        noRecords: 'Ingen poster',
        confirmDelete: 'Bekreft sletting',

        // Modal for lukking av dialog
        closeDialogueTitle: 'Lukk dialog',
        closeDialogueSubtitle1: 'Å lukke dette vinduet vil slette alle samtalehistorikker i dette vinduet.',
        closeDialogueSubtitle2: 'Denne handlingen kan ikke angres. Er du sikker på at du vil fortsette?',

        // Slett chat modal
        deleteChatTitle: 'Slett samtale?',
        deleteChatConfirmMessage: 'Etter sletting vil gjeldende samtalelogger ikke bli bevart.',

        // Meldingshandlinger
        copy: 'Kopier',
        copyText: 'Kopier tekst',
        copySuccess: 'Kopiert!',
        cancelEdit: 'Avbryt',
        sendEdit: 'Send',
        retry: 'Prøv igjen',
        clickToResend: 'Klikk for å sende på nytt',
        insufficientCreditsReply: 'Utilstrekkelig kreditt. Vennligst lad opp for å fortsette.',
        streamingTimeoutReply: 'Svar tidsavbrutt, vennligst prøv igjen',
        getMoreCredits: 'Få flere kreditter',

        // Modellvalg
        switchModel: 'Bytt modell',
        model: 'Modell',
        credits: 'kreditter',

        // Common operations
        edit: 'Rediger',
        cancel: 'Avbryt',
        confirm: 'Bekreft',
        processing: 'Behandler...',
        saving: 'Lagrer...',
        save: 'Lagre',
        enableDialogueModalTitle: 'Tips',
        enableDialogueModalContent: 'Aktiver dialogvinduet du vil bruke.',
        enableDialogueTip: 'Aktiver denne dialogen',
        disableDialogueTip: 'Deaktiver denne dialogen',

        // Message action menu
        startNewChatFromHere: 'Start ny chat herfra',

        // Heart related
        viewHeart: 'Se hjerte',
        heartMoment: 'Hjerteøyeblikk',
        unlocking: 'Låser opp...',
        unlock: 'Lås opp',

        // Voice guide
        voiceGuideText: 'Når aktivert vil karakterens svar automatisk generere taleavspilling.',

        // Media generation modal
        imageGeneration: 'Generer bilde',
        videoGeneration: 'Generer video',
        imageSubtitle: 'Generer eksklusive bilder basert på den aktuelle samtalen',
        videoSubtitle: 'Gi stillbilder liv, fang flytende øyeblikk',
        character: 'Karakter',
        currentCharacter: 'Nåværende karakter',
        uploadYourPhoto: 'Last opp bildet ditt',
        optional: '(Valgfritt)',
        imageHint: 'Du kan laste opp et bilde av deg selv, og jeg genererer et bilde av oss begge basert på utseendet ditt. Hvis du ikke laster opp, genererer jeg et solobilde basert på den aktuelle samtalen.',
        videoHint: 'Du kan laste opp et bilde av deg selv for å generere en duo-video med karakteren. Hvis du ikke laster opp, genereres en solo-karaktervideo.',
        startGenerate: 'Start generering',

        // Media result modal
        generatingImage: 'Genererer bilde...',
        generatingVideo: 'Genererer video...',
        imageGeneratingSubtitle: 'Bildegenerering tar et øyeblikk. Når det er ferdig, sender jeg bildet direkte til chatten. Fortsett gjerne å chatte.',
        videoGeneratingSubtitle: 'Videogenerering tar et øyeblikk. Når det er ferdig, sender jeg videoen direkte til chatten. Fortsett gjerne å chatte.',
        continueChat: 'Fortsett chat',
        imageComplete: 'Generering fullført',
        videoComplete: 'Generering fullført',
        imageCompleteSubtitle: 'Dette er vårt eksklusive minne',
        videoCompleteSubtitle: 'Dette er vårt eksklusive minne',
        saveImage: 'Lagre bilde',
        saveVideo: 'Lagre video',
        generateFailed: 'Generering mislyktes, prøv igjen senere',
        gotIt: 'Skjønner',

        // Chat input
        inputPlaceholder: 'Hva vil du si',

        // Edit message modal
        editMessage: 'Rediger melding',
        editDialogueTitle: 'Rediger melding',
        editPlaceholder: 'Skriv inn meldingsinnhold',
        editHint: 'Tips: Bruk () for å omslutte karakterhandlinger, uttrykk eller miljøbeskrivelser',

        // Rollback confirmation modal
        rollbackTitle: 'Start ny chat herfra',
        rollbackMessage: 'Å starte chatten herfra vil slette alle etterfølgende meldinger. Er du sikker?',

        // Mode selector
        switchChatMode: 'Bytt chatmodus',
        subscribe: 'Abonner',
        freeUnlimitedChat: 'Gratis ubegrenset chat',
        vipMemberBanner: 'Bli VIP og få',
        unlimitedChat: 'Ubegrenset chat',
        vipDescription: 'Intens & chill dobbel opplevelse',
        vipDescriptionSuffix: 'VIP 0 mynter ubegrenset chat, slipp løs fantasien.',
        vipFree: 'VIP gratis',
        vipOnly: 'Kun VIP',
        perMessage: '/melding',
        saveChanges: 'Lagre endringer',

        // Message list
        messageList: 'Meldinger',
        recent: 'Nylig',
        recentChats: 'Nylige chatter',
        loading: 'Laster...',
        emoji: '[Emoji]',
        image: '[Bilde]',
        audio: '[Lyd]',

        // Chat page empty state
        selectChatToStart: 'Velg en chat for å starte',
        selectFromList: 'Velg fra listen eller opprett en ny samtale',
        selectChatForDetail: 'Velg en chat for å se karakterdetaljer',

        // Toast messages
        toast: {
            noTopics: 'Ingen anbefalte emner tilgjengelig',
            getTopicsFailed: 'Kunne ikke hente anbefalte emner',
            noMessageToRefresh: 'Ingen melding å oppdatere',
            editSuccess: 'Redigering vellykket',
            editFailed: 'Redigering mislyktes',
            operationSuccess: 'Operasjon vellykket',
            operationFailed: 'Operasjon mislyktes',
            selectImageFile: 'Velg en bildefil',
            imageSizeLimit: 'Bildestørrelsen kan ikke overstige 100MB',
            uploading: 'Laster opp...',
            uploadSuccess: 'Opplasting fullført',
            uploadFailed: 'Opplasting mislyktes',
            insufficientCoins: 'Ikke nok mynter, vennligst fyll på',
            noImageToSave: 'Ingen bilde å lagre',
            noVideoToSave: 'Ingen video å lagre',
            saveSuccess: 'Lagret',
            saveFailed: 'Lagring mislyktes, prøv igjen',
            mediaLoadFailed: 'Medie kunne ikke lastes inn',
            switchSuccess: 'Byttet til',
            switchFailed: 'Klarte ikke å bytte modus',
            networkError: 'Nettverksfeil, prøv igjen',
            waitForAiReply: 'Vent på AI-svar',
            sendFailed: 'Kunne ikke sende, prøv igjen',
            regenerateFailed: 'Kunne ikke regenerere, prøv igjen',
            waitTimeout: 'Ventetid utløpt, prøv igjen',
            audioGenerateSuccess: 'Lyd generert',
            conversationNotExist: 'Samtalen finnes ikke',
            audioGenerateFailed: 'Kunne ikke generere lyd',
            mediaGenerating: 'Genererer...',
            imageGenerating: 'Genererer bilde...',
            videoGenerating: 'Genererer video...',
            mediaGenerateFailed: 'Generering mislyktes, prøv igjen',
            mediaNetworkError: 'Nettverksfeil, prøv igjen',
            heartUnlockSuccess: 'Låst opp',
            heartUnlockFailed: 'Kunne ikke låse opp',
            },
    },
    nl: {
        // Chat-pagina tabblad
        tabChat: 'Chat',
        creation: 'Creatie',
        historyRecord: 'Geschiedenis',
        dialogueRecord: 'Dialooggeschiedenis',
        systemPromptEntry: 'Prompt',
        systemPromptTitle: 'Systeemprompt',
        systemPromptSubtitle: 'Deze instructies worden bij elk gesprek met voorrang aan de AI gegeven.',
        systemPromptPlaceholder: 'Typ hier…',
        openSidebar: 'Zijbalk openen',
        noChat: 'Je hebt nog geen gesprek gestart~',
        newChat: 'Nieuwe chat',
        rename: 'Hernoemen',
        changeName: 'Naam wijzigen',
        renameChatTitle: 'Gesprek hernoemen',
        renameChatPlaceholder: 'Voer een nieuwe naam in',
        renameSuccess: 'Succesvol hernoemd',
        renameFailed: 'Hernoemen mislukt',
        renameChatLimitTip: 'Tekenlimiet: {max}',
        noCreation: 'Geen creaties',
        newCreation: 'Nieuwe creatie',
        delete: 'Verwijderen',
        deleteSuccess: 'Succesvol verwijderd',
        deleteFailed: 'Verwijderen mislukt',
        sendFailed: 'Verzenden mislukt, probeer opnieuw',
        needSendFirstMessage: 'Stuur eerst het eerste bericht',
        loadingMore: 'Meer berichten laden...',

        // Lege chat status
        emptyGreeting: 'Hallo,',
        emptySubtitle1: 'Hoe kan ik je vandaag',
        emptySubtitle2: 'helpen?',

        // Verwijder dialoogvenster modal
        reduceDialogueTitle: 'Dialoogvensters verminderen',
        reduceDialogueSubtitle: 'Records gedetecteerd in dialoogvensters. Het verminderen van het aantal vensters zal sommige dialogen en hun records verwijderen.',
        reduceDialogueSelect: 'Selecteer {count} venster(s) om te sluiten',
        windowName: 'Venster {index}',
        noRecords: 'Geen records',
        confirmDelete: 'Verwijdering bevestigen',

        // Sluit dialoog modal
        closeDialogueTitle: 'Dialoog sluiten',
        closeDialogueSubtitle1: 'Het sluiten van dit venster zal alle gespreksrecords in dit venster verwijderen.',
        closeDialogueSubtitle2: 'Deze actie kan niet ongedaan worden gemaakt. Weet je zeker dat je door wilt gaan?',

        // Chat verwijderen modal
        deleteChatTitle: 'Gesprek verwijderen?',
        deleteChatConfirmMessage: 'Na verwijdering worden de huidige gespreksgegevens niet bewaard.',

        // Berichtacties
        copy: 'Kopiëren',
        copyText: 'Tekst kopiëren',
        copySuccess: 'Gekopieerd!',
        cancelEdit: 'Annuleren',
        sendEdit: 'Verzenden',
        retry: 'Opnieuw proberen',
        clickToResend: 'Klik om opnieuw te verzenden',
        insufficientCreditsReply: 'Onvoldoende tegoed. Laad a.u.b. op om door te gaan.',
        streamingTimeoutReply: 'Reactie time-out, probeer het opnieuw',
        getMoreCredits: 'Meer tegoed krijgen',

        // Modelselectie
        switchModel: 'Model wisselen',
        model: 'Model',
        credits: 'tegoed',

        // Common operations
        edit: 'Bewerken',
        cancel: 'Annuleren',
        confirm: 'Bevestigen',
        processing: 'Bezig...',
        saving: 'Opslaan...',
        save: 'Opslaan',
        enableDialogueModalTitle: 'Tip',
        enableDialogueModalContent: 'Schakel het dialoogvenster in dat je wilt gebruiken.',
        enableDialogueTip: 'Dit dialoog inschakelen',
        disableDialogueTip: 'Dit dialoog uitschakelen',

        // Message action menu
        startNewChatFromHere: 'Start nieuwe chat vanaf hier',

        // Heart related
        viewHeart: 'Bekijk hart',
        heartMoment: 'Hartmoment',
        unlocking: 'Ontgrendelen...',
        unlock: 'Ontgrendelen',

        // Voice guide
        voiceGuideText: 'Wanneer ingeschakeld worden antwoorden van het personage automatisch als audio afgespeeld.',

        // Media generation modal
        imageGeneration: 'Genereer afbeelding',
        videoGeneration: 'Genereer video',
        imageSubtitle: 'Genereer exclusieve visuals op basis van het huidige gesprek',
        videoSubtitle: 'Breng stilstaande beelden tot leven, leg vloeiende momenten vast',
        character: 'Personage',
        currentCharacter: 'Huidig personage',
        uploadYourPhoto: 'Upload je foto',
        optional: '(Optioneel)',
        imageHint: 'Je kunt een foto van jezelf uploaden, dan genereer ik een foto van ons beiden op basis van je uiterlijk. Als je niets uploadt, genereer ik een solo-foto op basis van het huidige gesprek.',
        videoHint: 'Je kunt een foto van jezelf uploaden om een duo-video met het personage te genereren. Als je niets uploadt, wordt er een solo-video van het personage gegenereerd.',
        startGenerate: 'Start genereren',

        // Media result modal
        generatingImage: 'Afbeelding genereren...',
        generatingVideo: 'Video genereren...',
        imageGeneratingSubtitle: 'Het genereren van de foto duurt even. Zodra het klaar is, stuur ik de foto direct naar onze chat. Je kunt gerust blijven chatten.',
        videoGeneratingSubtitle: 'Het genereren van de video duurt even. Zodra het klaar is, stuur ik de video direct naar onze chat. Je kunt gerust blijven chatten.',
        continueChat: 'Doorgaan met chatten',
        imageComplete: 'Generatie voltooid',
        videoComplete: 'Generatie voltooid',
        imageCompleteSubtitle: 'Dit is onze exclusieve herinnering',
        videoCompleteSubtitle: 'Dit is onze exclusieve herinnering',
        saveImage: 'Foto opslaan',
        saveVideo: 'Video opslaan',
        generateFailed: 'Genereren mislukt, probeer later opnieuw',
        gotIt: 'Begrepen',

        // Chat input
        inputPlaceholder: 'Wat wil je zeggen',

        // Edit message modal
        editMessage: 'Bericht bewerken',
        editDialogueTitle: 'Bericht bewerken',
        editPlaceholder: 'Voer berichtinhoud in',
        editHint: 'Tip: gebruik () om acties, uitdrukkingen of omgevingsbeschrijvingen te omsluiten',

        // Rollback confirmation modal
        rollbackTitle: 'Start nieuwe chat vanaf hier',
        rollbackMessage: 'Het starten van een chat vanaf hier verwijdert alle volgende berichten. Weet je het zeker?',

        // Mode selector
        switchChatMode: 'Wissel chatmodus',
        subscribe: 'Abonneren',
        freeUnlimitedChat: 'Gratis onbeperkt chatten',
        vipMemberBanner: 'Word VIP en geniet',
        unlimitedChat: 'Onbeperkt chatten',
        vipDescription: 'Intens & chill dubbele ervaring',
        vipDescriptionSuffix: 'VIP 0 munten onbeperkt chatten, laat je fantasie los.',
        vipFree: 'VIP gratis',
        vipOnly: 'Alleen VIP',
        perMessage: '/bericht',
        saveChanges: 'Wijzigingen opslaan',

        // Message list
        messageList: 'Berichten',
        recent: 'Recent',
        recentChats: 'Recente chats',
        loading: 'Laden...',
        emoji: '[Emoji]',
        image: '[Afbeelding]',
        audio: '[Audio]',

        // Chat page empty state
        selectChatToStart: 'Selecteer een chat om te starten',
        selectFromList: 'Kies uit de lijst of maak een nieuw gesprek',
        selectChatForDetail: 'Selecteer een chat om personagedetails te bekijken',

        // Toast messages
        toast: {
            noTopics: 'Geen aanbevolen onderwerpen beschikbaar',
            getTopicsFailed: 'Ophalen van aanbevolen onderwerpen mislukt',
            noMessageToRefresh: 'Geen bericht om te verversen',
            editSuccess: 'Bewerken gelukt',
            editFailed: 'Bewerken mislukt',
            operationSuccess: 'Bewerking geslaagd',
            operationFailed: 'Bewerking mislukt',
            selectImageFile: 'Selecteer een afbeeldingsbestand',
            imageSizeLimit: 'Afbeelding mag niet groter zijn dan 100MB',
            uploading: 'Uploaden...',
            uploadSuccess: 'Upload geslaagd',
            uploadFailed: 'Upload mislukt',
            insufficientCoins: 'Onvoldoende munten, laad op',
            noImageToSave: 'Geen afbeelding om op te slaan',
            noVideoToSave: 'Geen video om op te slaan',
            saveSuccess: 'Opgeslagen',
            saveFailed: 'Opslaan mislukt, probeer opnieuw',
            mediaLoadFailed: 'Media kon niet laden',
            switchSuccess: 'Gewisseld naar',
            switchFailed: 'Wisselen van modus mislukt',
            networkError: 'Netwerkfout, probeer opnieuw',
            waitForAiReply: 'Wacht op AI-antwoord',
            sendFailed: 'Verzenden mislukt, probeer opnieuw',
            regenerateFailed: 'Opnieuw genereren mislukt, probeer opnieuw',
            waitTimeout: 'Wacht timeout, probeer opnieuw',
            audioGenerateSuccess: 'Audio succesvol gegenereerd',
            conversationNotExist: 'Gesprek bestaat niet',
            audioGenerateFailed: 'Audio genereren mislukt',
            mediaGenerating: 'Genereren...',
            imageGenerating: 'Afbeelding genereren...',
            videoGenerating: 'Video genereren...',
            mediaGenerateFailed: 'Genereren mislukt, probeer opnieuw',
            mediaNetworkError: 'Netwerkfout, probeer opnieuw',
            heartUnlockSuccess: 'Ontgrendeld',
            heartUnlockFailed: 'Ontgrendelen mislukt',
            },
    },
    id: {
        // Tab halaman obrolan
        tabChat: 'Chat',
        creation: 'Kreasi',
        historyRecord: 'Riwayat',
        dialogueRecord: 'Riwayat Dialog',
        systemPromptEntry: 'Prompt',
        systemPromptTitle: 'Prompt sistem',
        systemPromptSubtitle: 'Instruksi ini akan diprioritaskan dan diberikan terlebih dahulu kepada AI di setiap percakapan.',
        systemPromptPlaceholder: 'Ketik di sini…',
        openSidebar: 'Buka bilah sisi',
        noChat: 'Kamu belum memulai percakapan apa pun~',
        newChat: 'Obrolan baru',
        rename: 'Ganti nama',
        changeName: 'Ubah nama',
        renameChatTitle: 'Ganti nama percakapan',
        renameChatPlaceholder: 'Masukkan nama baru',
        renameSuccess: 'Berhasil mengganti nama',
        renameFailed: 'Gagal mengganti nama',
        renameChatLimitTip: 'Batas karakter: {max}',
        noCreation: 'Belum ada kreasi',
        newCreation: 'Kreasi baru',
        delete: 'Hapus',
        deleteSuccess: 'Berhasil dihapus',
        deleteFailed: 'Gagal menghapus',
        sendFailed: 'Gagal mengirim, silakan coba lagi',
        needSendFirstMessage: 'Silakan kirim pesan pertama terlebih dahulu',
        loadingMore: 'Memuat lebih banyak pesan...',

        // Status obrolan kosong
        emptyGreeting: 'Halo,',
        emptySubtitle1: 'Apa yang bisa saya bantu',
        emptySubtitle2: 'hari ini?',

        // Modal pengurangan dialog
        reduceDialogueTitle: 'Kurangi jendela dialog',
        reduceDialogueSubtitle: 'Rekaman terdeteksi di jendela dialog. Mengurangi jumlah jendela akan menghapus beberapa dialog dan rekamannya.',
        reduceDialogueSelect: 'Pilih {count} jendela untuk ditutup',
        windowName: 'Jendela {index}',
        noRecords: 'Tidak ada rekaman',
        confirmDelete: 'Konfirmasi hapus',

        // Modal tutup dialog
        closeDialogueTitle: 'Tutup dialog',
        closeDialogueSubtitle1: 'Menutup jendela ini akan menghapus semua catatan percakapan di jendela ini.',
        closeDialogueSubtitle2: 'Tindakan ini tidak dapat dibatalkan. Apakah Anda yakin ingin melanjutkan?',

        // Modal hapus chat
        deleteChatTitle: 'Hapus percakapan?',
        deleteChatConfirmMessage: 'Setelah dihapus, catatan percakapan saat ini tidak akan disimpan.',

        // Tindakan pesan
        copy: 'Salin',
        copyText: 'Salin teks',
        copySuccess: 'Tersalin!',
        cancelEdit: 'Batal',
        sendEdit: 'Kirim',
        retry: 'Coba lagi',
        clickToResend: 'Klik untuk mengirim ulang',
        insufficientCreditsReply: 'Kredit tidak mencukupi. Silakan isi ulang untuk melanjutkan.',
        streamingTimeoutReply: 'Waktu respons habis, silakan coba lagi',
        getMoreCredits: 'Dapatkan lebih banyak kredit',

        // Pilihan model
        switchModel: 'Ganti model',
        model: 'Model',
        credits: 'kredit',

        // Common operations
        edit: 'Edit',
        cancel: 'Batal',
        confirm: 'Konfirmasi',
        processing: 'Memproses...',
        saving: 'Menyimpan...',
        save: 'Simpan',
        enableDialogueModalTitle: 'Tips',
        enableDialogueModalContent: 'Silakan aktifkan jendela dialog yang ingin Anda gunakan.',
        enableDialogueTip: 'Aktifkan dialog ini',
        disableDialogueTip: 'Nonaktifkan dialog ini',

        // Message action menu
        startNewChatFromHere: 'Mulai chat baru dari sini',

        // Heart related
        viewHeart: 'Lihat Hati',
        heartMoment: 'Momen Hati',
        unlocking: 'Membuka kunci...',
        unlock: 'Buka kunci',

        // Voice guide
        voiceGuideText: 'Jika diaktifkan, balasan karakter akan otomatis menghasilkan pemutaran suara.',

        // Media generation modal
        imageGeneration: 'Buat Gambar',
        videoGeneration: 'Buat Video',
        imageSubtitle: 'Buat visual eksklusif berdasarkan percakapan saat ini',
        videoSubtitle: 'Hidupkan gambar diam, tangkap momen yang mengalir',
        character: 'Karakter',
        currentCharacter: 'Karakter Saat Ini',
        uploadYourPhoto: 'Unggah fotomu',
        optional: '(Opsional)',
        imageHint: 'Kamu dapat mengunggah foto dirimu, dan aku akan membuat foto kita berdua berdasarkan penampilanmu. Jika tidak diunggah, aku akan membuat foto solo berdasarkan percakapan saat ini.',
        videoHint: 'Kamu dapat mengunggah fotomu untuk membuat video duo dengan karakter. Jika tidak diunggah, akan dibuat video solo karakter.',
        startGenerate: 'Mulai Buat',

        // Media result modal
        generatingImage: 'Membuat gambar...',
        generatingVideo: 'Membuat video...',
        imageGeneratingSubtitle: 'Pembuatan foto butuh sebentar. Setelah selesai, aku akan mengirim foto langsung ke chat kita. Silakan lanjut mengobrol.',
        videoGeneratingSubtitle: 'Pembuatan video butuh sebentar. Setelah selesai, aku akan mengirim video langsung ke chat kita. Silakan lanjut mengobrol.',
        continueChat: 'Lanjut Chat',
        imageComplete: 'Pembuatan Selesai',
        videoComplete: 'Pembuatan Selesai',
        imageCompleteSubtitle: 'Ini adalah kenangan eksklusif kita',
        videoCompleteSubtitle: 'Ini adalah kenangan eksklusif kita',
        saveImage: 'Simpan Foto',
        saveVideo: 'Simpan Video',
        generateFailed: 'Pembuatan gagal, coba lagi nanti',
        gotIt: 'Mengerti',

        // Chat input
        inputPlaceholder: 'Apa yang ingin kamu katakan',

        // Edit message modal
        editMessage: 'Edit Pesan',
        editDialogueTitle: 'Edit Pesan',
        editPlaceholder: 'Masukkan isi pesan',
        editHint: 'Tip: Gunakan () untuk membungkus aksi karakter, ekspresi, atau deskripsi lingkungan',

        // Rollback confirmation modal
        rollbackTitle: 'Mulai chat baru dari sini',
        rollbackMessage: 'Memulai chat dari sini akan menghapus semua pesan berikutnya. Yakin?',

        // Mode selector
        switchChatMode: 'Ganti Mode Chat',
        subscribe: 'Berlangganan',
        freeUnlimitedChat: 'Chat Gratis Tanpa Batas',
        vipMemberBanner: 'Jadi VIP dan nikmati',
        unlimitedChat: 'Chat Tanpa Batas',
        vipDescription: 'Pengalaman ganda Intens & Chill',
        vipDescriptionSuffix: 'VIP 0 koin chat tanpa batas, lepaskan semua imajinasimu.',
        vipFree: 'VIP Gratis',
        vipOnly: 'Khusus VIP',
        perMessage: '/pesan',
        saveChanges: 'Simpan Perubahan',

        // Message list
        messageList: 'Pesan',
        recent: 'Terbaru',
        recentChats: 'Chat Terbaru',
        loading: 'Memuat...',
        emoji: '[Emoji]',
        image: '[Gambar]',
        audio: '[Audio]',

        // Chat page empty state
        selectChatToStart: 'Pilih chat untuk mulai',
        selectFromList: 'Pilih dari daftar atau buat percakapan baru',
        selectChatForDetail: 'Pilih chat untuk melihat detail karakter',

        // Toast messages
        toast: {
            noTopics: 'Tidak ada topik yang direkomendasikan',
            getTopicsFailed: 'Gagal mengambil topik yang direkomendasikan',
            noMessageToRefresh: 'Tidak ada pesan untuk disegarkan',
            editSuccess: 'Berhasil diedit',
            editFailed: 'Edit gagal',
            operationSuccess: 'Operasi berhasil',
            operationFailed: 'Operasi gagal',
            selectImageFile: 'Pilih file gambar',
            imageSizeLimit: 'Ukuran gambar tidak boleh melebihi 100MB',
            uploading: 'Mengunggah...',
            uploadSuccess: 'Unggah berhasil',
            uploadFailed: 'Unggah gagal',
            insufficientCoins: 'Koin tidak cukup, silakan isi ulang',
            noImageToSave: 'Tidak ada gambar untuk disimpan',
            noVideoToSave: 'Tidak ada video untuk disimpan',
            saveSuccess: 'Berhasil disimpan',
            saveFailed: 'Gagal menyimpan, coba lagi',
            mediaLoadFailed: 'Media gagal dimuat',
            switchSuccess: 'Berhasil beralih ke',
            switchFailed: 'Gagal mengganti mode',
            networkError: 'Kesalahan jaringan, coba lagi',
            waitForAiReply: 'Tunggu balasan AI',
            sendFailed: 'Gagal mengirim, coba lagi',
            regenerateFailed: 'Gagal membuat ulang, coba lagi',
            waitTimeout: 'Waktu tunggu habis, coba lagi',
            audioGenerateSuccess: 'Audio berhasil dibuat',
            conversationNotExist: 'Percakapan tidak ada',
            audioGenerateFailed: 'Gagal membuat audio',
            mediaGenerating: 'Sedang dibuat...',
            imageGenerating: 'Sedang membuat gambar...',
            videoGenerating: 'Sedang membuat video...',
            mediaGenerateFailed: 'Pembuatan gagal, coba lagi',
            mediaNetworkError: 'Kesalahan jaringan, coba lagi',
            heartUnlockSuccess: 'Berhasil dibuka',
            heartUnlockFailed: 'Gagal membuka',
            },
    },
    tr: {
        // Sohbet sayfası sekmesi
        tabChat: 'Sohbet',
        creation: 'Yaratım',
        historyRecord: 'Geçmiş',
        dialogueRecord: 'Diyalog Geçmişi',
        systemPromptEntry: 'Prompt',
        systemPromptTitle: 'Sistem istemi',
        systemPromptSubtitle: 'Bu talimatlar her sohbet sırasında öncelikli olarak yapay zekâya verilecektir.',
        systemPromptPlaceholder: 'Buraya yaz…',
        openSidebar: 'Kenar çubuğunu aç',
        noChat: 'Henüz hiç sohbet başlatmadınız~',
        newChat: 'Yeni sohbet',
        rename: 'Yeniden adlandır',
        changeName: 'Adı değiştir',
        renameChatTitle: 'Konuşmayı yeniden adlandır',
        renameChatPlaceholder: 'Yeni bir ad girin',
        renameSuccess: 'Yeniden adlandırma başarılı',
        renameFailed: 'Yeniden adlandırma başarısız',
        renameChatLimitTip: 'Karakter sınırı: {max}',
        noCreation: 'Yaratım yok',
        newCreation: 'Yeni yaratım',
        delete: 'Sil',
        deleteSuccess: 'Başarıyla silindi',
        deleteFailed: 'Silme başarısız',
        sendFailed: 'Gönderme başarısız, lütfen tekrar deneyin',
        needSendFirstMessage: 'Lütfen önce ilk mesajı gönderin',
        loadingMore: 'Daha fazla mesaj yükleniyor...',

        // Boş sohbet durumu
        emptyGreeting: 'Merhaba,',
        emptySubtitle1: 'Bugün size nasıl',
        emptySubtitle2: 'yardımcı olabilirim?',

        // Diyalog azaltma modalı
        reduceDialogueTitle: 'Diyalog pencerelerini azalt',
        reduceDialogueSubtitle: 'Diyalog pencerelerinde kayıtlar tespit edildi. Pencere sayısını azaltmak bazı diyalogları ve kayıtlarını silecektir.',
        reduceDialogueSelect: 'Kapatılacak {count} pencere seçin',
        windowName: 'Pencere {index}',
        noRecords: 'Kayıt yok',
        confirmDelete: 'Silmeyi onayla',

        // Diyalog kapatma modalı
        closeDialogueTitle: 'Diyaloğu kapat',
        closeDialogueSubtitle1: 'Bu pencereyi kapatmak, bu penceredeki tüm konuşma kayıtlarını silecektir.',
        closeDialogueSubtitle2: 'Bu işlem geri alınamaz. Devam etmek istediğinizden emin misiniz?',

        // Sohbet silme modalı
        deleteChatTitle: 'Konuşmayı sil?',
        deleteChatConfirmMessage: 'Sildikten sonra mevcut konuşma kayıtları korunmayacaktır.',

        // Mesaj işlemleri
        copy: 'Kopyala',
        copyText: 'Metni kopyala',
        copySuccess: 'Kopyalandı!',
        cancelEdit: 'İptal',
        sendEdit: 'Gönder',
        retry: 'Tekrar dene',
        clickToResend: 'Tekrar göndermek için tıklayın',
        insufficientCreditsReply: 'Yetersiz kredi. Devam etmek için lütfen yeniden yükleyin.',
        streamingTimeoutReply: 'Yanıt zaman aşımına uğradı, lütfen tekrar deneyin',
        getMoreCredits: 'Daha fazla kredi al',

        // Model seçimi
        switchModel: 'Model değiştir',
        model: 'Model',
        credits: 'kredi',

        // Common operations
        edit: 'Düzenle',
        cancel: 'İptal',
        confirm: 'Onayla',
        processing: 'İşleniyor...',
        saving: 'Kaydediliyor...',
        save: 'Kaydet',
        enableDialogueModalTitle: 'İpucu',
        enableDialogueModalContent: 'Lütfen kullanmak istediğiniz diyalog penceresini etkinleştirin.',
        enableDialogueTip: 'Bu diyaloğu etkinleştir',
        disableDialogueTip: 'Bu diyaloğu devre dışı bırak',

        // Message action menu
        startNewChatFromHere: 'Buradan yeni sohbet başlat',

        // Heart related
        viewHeart: 'Kalbi Gör',
        heartMoment: 'Kalp Anı',
        unlocking: 'Kilit açılıyor...',
        unlock: 'Kilidi Aç',

        // Voice guide
        voiceGuideText: 'Etkinleştirildiğinde, karakter yanıtları otomatik olarak sesli oynatma oluşturur.',

        // Media generation modal
        imageGeneration: 'Görsel Oluştur',
        videoGeneration: 'Video Oluştur',
        imageSubtitle: 'Mevcut konuşmaya göre özel görseller oluştur',
        videoSubtitle: 'Durağan görüntüleri canlandır, akıcı anları yakala',
        character: 'Karakter',
        currentCharacter: 'Mevcut Karakter',
        uploadYourPhoto: 'Fotoğrafını yükle',
        optional: '(İsteğe bağlı)',
        imageHint: 'Kendi fotoğrafını yükleyebilirsin; görünümüne göre ikimizin fotoğrafını oluştururum. Yüklenmezse, mevcut konuşmaya göre tekli bir fotoğraf oluştururum.',
        videoHint: 'Kendi fotoğrafını yükleyerek karakterle bir duo video oluşturabilirsin. Yüklenmezse tekli karakter videosu oluşturulur.',
        startGenerate: 'Oluşturmayı Başlat',

        // Media result modal
        generatingImage: 'Görsel oluşturuluyor...',
        generatingVideo: 'Video oluşturuluyor...',
        imageGeneratingSubtitle: 'Görsel oluşturma biraz zaman alır. Tamamlandığında görseli doğrudan sohbete göndereceğim. Sohbete devam edebilirsin.',
        videoGeneratingSubtitle: 'Video oluşturma biraz zaman alır. Tamamlandığında videoyu doğrudan sohbete göndereceğim. Sohbete devam edebilirsin.',
        continueChat: 'Sohbete devam et',
        imageComplete: 'Oluşturma tamamlandı',
        videoComplete: 'Oluşturma tamamlandı',
        imageCompleteSubtitle: 'Bu bizim özel anımız',
        videoCompleteSubtitle: 'Bu bizim özel anımız',
        saveImage: 'Fotoğrafı Kaydet',
        saveVideo: 'Videoyu Kaydet',
        generateFailed: 'Oluşturma başarısız oldu, lütfen daha sonra tekrar deneyin',
        gotIt: 'Anladım',

        // Chat input
        inputPlaceholder: 'Ne söylemek istersin',

        // Edit message modal
        editMessage: 'Mesajı Düzenle',
        editDialogueTitle: 'Mesajı Düzenle',
        editPlaceholder: 'Mesaj içeriğini girin',
        editHint: 'İpucu: Karakter eylemlerini, ifadeleri veya ortam açıklamalarını () içine alın',

        // Rollback confirmation modal
        rollbackTitle: 'Buradan yeni sohbet başlat',
        rollbackMessage: 'Buradan sohbet başlatmak sonraki tüm mesajları siler. Emin misiniz?',

        // Mode selector
        switchChatMode: 'Sohbet Modunu Değiştir',
        subscribe: 'Abone Ol',
        freeUnlimitedChat: 'Ücretsiz sınırsız sohbet',
        vipMemberBanner: 'VIP ol ve keyfini çıkar',
        unlimitedChat: 'Sınırsız sohbet',
        vipDescription: 'Yoğun & sakin çift deneyim',
        vipDescriptionSuffix: 'VIP 0 jeton sınırsız sohbet, hayal gücünü serbest bırak.',
        vipFree: 'VIP Ücretsiz',
        vipOnly: 'Yalnızca VIP',
        perMessage: '/mesaj',
        saveChanges: 'Değişiklikleri Kaydet',

        // Message list
        messageList: 'Mesajlar',
        recent: 'Son',
        recentChats: 'Son sohbetler',
        loading: 'Yükleniyor...',
        emoji: '[Emoji]',
        image: '[Görsel]',
        audio: '[Ses]',

        // Chat page empty state
        selectChatToStart: 'Başlamak için bir sohbet seçin',
        selectFromList: 'Listeden seçin veya yeni bir konuşma oluşturun',
        selectChatForDetail: 'Karakter ayrıntılarını görmek için bir sohbet seçin',

        // Toast messages
        toast: {
            noTopics: 'Önerilen konu yok',
            getTopicsFailed: 'Önerilen konular alınamadı',
            noMessageToRefresh: 'Yenilenecek mesaj yok',
            editSuccess: 'Düzenleme başarılı',
            editFailed: 'Düzenleme başarısız',
            operationSuccess: 'İşlem başarılı',
            operationFailed: 'İşlem başarısız',
            selectImageFile: 'Lütfen bir görsel dosyası seçin',
            imageSizeLimit: 'Görsel boyutu 100MB\'yi aşamaz',
            uploading: 'Yükleniyor...',
            uploadSuccess: 'Yükleme başarılı',
            uploadFailed: 'Yükleme başarısız',
            insufficientCoins: 'Yetersiz jeton, lütfen yükleme yapın',
            noImageToSave: 'Kaydedilecek görsel yok',
            noVideoToSave: 'Kaydedilecek video yok',
            saveSuccess: 'Kaydedildi',
            saveFailed: 'Kaydetme başarısız, lütfen tekrar deneyin',
            mediaLoadFailed: 'Medya yüklenemedi',
            switchSuccess: 'Şuna geçildi',
            switchFailed: 'Mod değiştirme başarısız',
            networkError: 'Ağ hatası, lütfen tekrar deneyin',
            waitForAiReply: 'AI yanıtı bekleniyor',
            sendFailed: 'Gönderilemedi, lütfen tekrar deneyin',
            regenerateFailed: 'Yeniden oluşturma başarısız, lütfen tekrar deneyin',
            waitTimeout: 'Bekleme zaman aşımı, lütfen tekrar deneyin',
            audioGenerateSuccess: 'Ses başarıyla oluşturuldu',
            conversationNotExist: 'Konuşma mevcut değil',
            audioGenerateFailed: 'Ses oluşturma başarısız',
            mediaGenerating: 'Oluşturuluyor...',
            imageGenerating: 'Görsel oluşturuluyor...',
            videoGenerating: 'Video oluşturuluyor...',
            mediaGenerateFailed: 'Oluşturma başarısız, lütfen tekrar deneyin',
            mediaNetworkError: 'Ağ hatası, lütfen tekrar deneyin',
            heartUnlockSuccess: 'Kilit başarıyla açıldı',
            heartUnlockFailed: 'Kilit açılamadı',
        },
    },
}
